var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2638.519,
    height: 1335.969,
    viewBox: "0 0 2638.519 1335.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3464",
    "data-name": "Trazado 3464",
    d: "M224.094,337.7q-30.419,2.829-58.364,5.978H165.7c-9.508,1.079-18.84,2.191-27.945,3.328v238.83H1287.012l81.1-126.7s-28.761-6.306-70.127-59.952-37.143-89.432-37.143-89.432l-.324-.032c-5.361-.292-78.33-4.311-200.284-5.764-.3,0-.6-.015-.9-.021-1.813-.029-3.717-.044-5.7-.056q-37.925-.417-81.758-.442c-186.453,0-449.464,6.756-747.784,34.262",
    transform: "translate(-137.753 -303.441)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3465",
    "data-name": "Trazado 3465",
    d: "M763.214,343.491s123.059,28.4,124.13,37.336c.032.392-.225.749-.778,1.141-12.283,8.511-169.2,16.439-180.741,21.478-10.918,4.776-2.047,9-.292,9.78.032,0,.1.032.129.032l.164.064L574.509,462.36s63.529,6.109,63.529,13.029v.1c-.617,3.834-38.149,23.365-74.157,41.3-5.068,2.5-10.1,5-14.98,7.408-20.794,10.2-39.091,19.01-46.858,22.68-2.5,1.2-3.9,1.886-3.9,1.886L321.43,566.476H492.88l-18.016,15.208h505.88l59.1-138.884L907.331,305.6Z",
    transform: "translate(-321.43 -305.6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_74",
    "data-name": "Rect\\xE1ngulo 74",
    width: 1949.745,
    height: 1169.848,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_69",
    "data-name": "Rect\\xE1ngulo 69",
    width: 206.695,
    height: 263.948,
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3466",
    "data-name": "Trazado 3466",
    d: "M650.947,595.655,520.7,571.793l-7.469-1.366-68.983-12.64,25.187-194.7-.178-.07-.111-.047c-1.758-.755-10.622-5.007.29-9.774,2.849-1.243,14.268-3.549,30.464-5.108,10.4-1,22.663-2.065,35.622-3.173,14.9-1.278,68.461-5.316,66.8-5.532,19.961-2.258,44.4-5.27,47.862-7.671-5.551,8.473-39.436,63.757-23.961,129.42,16.831,71.413,24.719,134.527,24.719,134.527",
    transform: "translate(-444.252 -331.708)",
    fill: "#9b9b9b",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_71",
    "data-name": "Rect\\xE1ngulo 71",
    width: 160.553,
    height: 181.321,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3467",
    "data-name": "Trazado 3467",
    d: "M485.708,394.8l-8.285,143.847L379.6,576.124s-55.223-26.43-54.436-28.006,25.257-39.111,25.257-39.111Z",
    transform: "translate(-325.153 -394.803)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -4.373,
    y1: 0.905,
    x2: -4.359,
    y2: 0.905,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#977cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4513b6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_73",
    "data-name": "Rect\\xE1ngulo 73",
    width: 599.486,
    height: 57.586,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3468",
    "data-name": "Trazado 3468",
    d: "M606.229,322.817,792.06,341.9s-69.071,35.563-152.168,38.3-447.318-22.517-447.318-22.517L362.19,332.36H467.38l-41.6-9.543Z",
    transform: "translate(-192.574 -322.817)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.99,
    y1: 1.801,
    x2: -0.985,
    y2: 1.801,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59000e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_81",
    "data-name": "Rect\\xE1ngulo 81",
    width: 165.282,
    height: 21.3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3472",
    "data-name": "Trazado 3472",
    d: "M503.818,330.513c6.32-2.223,69.434-11.69,69.434-11.69H489.624l-81.655,21.3Z",
    transform: "translate(-407.969 -318.823)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -16.024,
    y1: 2.919,
    x2: -15.986,
    y2: 2.919,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3474",
    "data-name": "Trazado 3474",
    d: "M299.1,414.513l162.554,16.574,29.643,4.462,7.331-2.55L502,387.824Z",
    transform: "translate(-322.324 -387.824)",
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_87",
    "data-name": "Rect\\xE1ngulo 87",
    width: 1949.745,
    height: 1169.848,
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_86",
    "data-name": "Rect\\xE1ngulo 86",
    width: 138.84,
    height: 176.86,
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3475",
    "data-name": "Trazado 3475",
    d: "M510.015,509.387l-45.928,12.172,1.749,18.99-83.627-2.764,1.8-105.091c7.031-3.358,37.052-15.569,58.647-26.136l1.913-1.393c36.022-17.928,75.87-37.637,76.481-41.477Z",
    transform: "translate(-382.209 -363.688)",
    fill: "#9b9b9b",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3476",
    "data-name": "Trazado 3476",
    d: "M946.369,315.156,937.4,329.943,824.641,363.216s-8.87,31.454-43.185,52.319S724,446.243,724,446.243l2.632,24.795s-2.182.357-6.11,1.006c-30.84,5.136-169.046,28.565-188.77,41.889l-22.227,14.948-86.11,34.411H1537.7V355.3c-102.8-8.964-223.271-18.788-326.68-25.359-92.971-5.917-153.771-9.458-193.285-11.6h-.225c-57.217-3.091-69.77-3.182-71.024-3.182h-.111",
    transform: "translate(-423.421 -315.156)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3477",
    "data-name": "Trazado 3477",
    d: "M1137.713,366.183l-4.205,16.828L924.781,397.739l-92.713-8.724-5.188-.483-7.428-.7-28.857-2.714,48.385-18.934L738.912,385.117H695.924l-32.864-2.085-136.867-8.669,2.638,24.8s64.128,3.074,126.352,5.393c16.2.605,32.27,1.161,47.049,1.594,11.947.351,25.915.79,40.892,1.278,18.013.585,37.491,1.246,56.682,1.9,7.013.243,13.986.483,20.835.723l6.346.219,4.522.158c47.434,1.661,86.364,3.082,86.364,3.082l149.805-15.778h95.284l-23.142-12.623s2.106-10.52,8.543-14.725S1240.8,357.9,1240.8,357.9l18.937-5.39Z",
    transform: "translate(-526.193 -352.507)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_91",
    "data-name": "Rect\\xE1ngulo 91",
    width: 87.946,
    height: 24.4,
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3478",
    "data-name": "Trazado 3478",
    d: "M658.243,387.347c-14.983-.491-28.948-.93-40.895-1.281-14.775-.436-30.849-.988-47.051-1.594l7.879-21.528,32.864,2.085h42.986Z",
    transform: "translate(-570.297 -362.944)",
    fill: "#9b9b9b",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_93",
    "data-name": "Rect\\xE1ngulo 93",
    width: 30.048,
    height: 24.941,
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3479",
    "data-name": "Trazado 3479",
    d: "M646.645,388.6c-6.849-.24-13.825-.48-20.835-.722L616.6,363.657l28.857,2.714Z",
    transform: "translate(-616.598 -363.657)",
    fill: "#9b9b9b",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_95",
    "data-name": "Rect\\xE1ngulo 95",
    width: 5.191,
    height: 21.905,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3480",
    "data-name": "Trazado 3480",
    d: "M634.2,365.312l-.561,21.417q-2.25-.079-4.518-.155l-.111-21.75Z",
    transform: "translate(-629.005 -364.824)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -244.774,
    y1: 12.053,
    x2: -244.385,
    y2: 12.053,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_97",
    "data-name": "Rect\\xE1ngulo 97",
    width: 336.782,
    height: 65.003,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3481",
    "data-name": "Trazado 3481",
    d: "M560.609,353.473l250.757,31.741,8.712-2.632,77.312-13.24L673.374,320.211Z",
    transform: "translate(-560.609 -320.211)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -6.291,
    y1: 1.724,
    x2: -6.28,
    y2: 1.724,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_99",
    "data-name": "Rect\\xE1ngulo 99",
    width: 559,
    height: 41.864,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3482",
    "data-name": "Trazado 3482",
    d: "M1019.466,381.253l-37.154,5.633H769.3l-308.834,23.78C480.2,397.374,618.384,373.915,649.233,368.8Z",
    transform: "translate(-460.466 -368.803)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -3.656,
    y1: 1.019,
    x2: -3.648,
    y2: 1.019,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3483",
    "data-name": "Trazado 3483",
    d: "M657.642,413.4c-2.114,19.2-7.051,32.911-11.9,42.229l4.323.117c4.919-12.161,8.68-25.816,9.175-39.775,1.512-42.8-28.863-86.455-28.863-86.455S661.415,379.1,657.642,413.4",
    transform: "translate(-630.373 -329.519)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -26.071,
    y1: 2.891,
    x2: -26.029,
    y2: 2.891,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3484",
    "data-name": "Trazado 3484",
    d: "M633.014,325.534c-5.94,2.729-8.037,10.874-4.674,18.194s10.9,11.041,16.846,8.312,8.037-10.874,4.674-18.194c-2.615-5.691-7.753-9.207-12.7-9.207a9.844,9.844,0,0,0-4.141.895",
    transform: "translate(-626.735 -324.639)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.51,
    cy: 0.479,
    r: 0.339,
    gradientTransform: "matrix(1.024, 0, 0, -1, 1.156, 19.968)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232,
    stopColor: "#ffc100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#ffce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#ffe500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3485",
    "data-name": "Trazado 3485",
    d: "M631.243,321.1a2.886,2.886,0,0,0-1.006,3.91c.722,1.573,2.018,6.689,3.3,6.1s2.053-6.654,1.331-8.227a3.185,3.185,0,0,0-2.735-1.98,2.085,2.085,0,0,0-.886.193",
    transform: "translate(-629.892 -320.909)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.582,
    cy: 0.48,
    r: 0.327,
    gradientTransform: "matrix(1.232, 0, 0, -1, 42.509, 64.534)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3486",
    "data-name": "Trazado 3486",
    d: "M628.829,334.988a1.345,1.345,0,1,0,1.521.749,1.335,1.335,0,0,0-1.147-.831.893.893,0,0,0-.374.082",
    transform: "translate(-628.265 -334.906)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.51,
    cy: 0.479,
    r: 0.339,
    gradientTransform: "matrix(1.025, 0, 0, -1, 13.142, 201.948)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3487",
    "data-name": "Trazado 3487",
    d: "M637.383,332.142c-.971.448-3.24.974-2.688,2.17s3.711,2.623,4.685,2.176a2.2,2.2,0,0,0,.766-2.983A2.424,2.424,0,0,0,638.065,332a1.634,1.634,0,0,0-.682.146",
    transform: "translate(-634.61 -331.996)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.528,
    cy: 0.531,
    r: 0.352,
    gradientTransform: "matrix(0.901, 0, 0, -1, -22.889, 101.37)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3488",
    "data-name": "Trazado 3488",
    d: "M635.908,330.69a.964.964,0,1,0,1.091.535.956.956,0,0,0-.822-.594.611.611,0,0,0-.269.059",
    transform: "translate(-635.504 -330.631)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.509,
    cy: 0.479,
    r: 0.339,
    gradientTransform: "matrix(1.025, 0, 0, -1, 18.774, 291.442)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3489",
    "data-name": "Trazado 3489",
    d: "M705.477,424.766l.737-.076c-7.49-45.232-25.775-82.65-25.775-82.65s18.206,41.4,25.038,82.726",
    transform: "translate(-680.439 -342.04)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -38.775,
    y1: 3.905,
    x2: -38.717,
    y2: 3.905,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3492",
    "data-name": "Trazado 3492",
    d: "M678.22,340.883a1.345,1.345,0,1,0,1.518.749,1.334,1.334,0,0,0-1.144-.831.881.881,0,0,0-.374.082",
    transform: "translate(-677.652 -340.801)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.512,
    cy: 0.479,
    r: 0.339,
    gradientTransform: "matrix(1.024, 0, 0, -1, 13.886, 192.118)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3493",
    "data-name": "Trazado 3493",
    d: "M718.525,411.463l.564-.006c2.755-32.142,14.945-65.7,14.945-65.7s-12.418,30.325-15.509,65.71",
    transform: "translate(-718.525 -345.753)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -30.753,
    y1: 9.656,
    x2: -30.71,
    y2: 9.656,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3496",
    "data-name": "Trazado 3496",
    d: "M725.394,345.38a.823.823,0,1,0,1.105-.64.6.6,0,0,0-.237-.044.993.993,0,0,0-.869.684",
    transform: "translate(-725.315 -344.696)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.521,
    cy: 0.492,
    r: 0.361,
    gradientTransform: "matrix(0, -1, 0.965, 0, -941.405, -684.554)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3500",
    "data-name": "Trazado 3500",
    d: "M750.283,342.1a.612.612,0,1,0,.822-.477.472.472,0,0,0-.179-.032.734.734,0,0,0-.643.509",
    transform: "translate(-750.224 -341.591)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.521,
    cy: 0.492,
    r: 0.361,
    gradientTransform: "matrix(0, -1, 0.965, 0, -1309.503, -954.356)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3501",
    "data-name": "Trazado 3501",
    d: "M762.086,351.69a1.337,1.337,0,0,0,.217,1.86c.579.561,1.243,3.457,1.7,2.989s.526-4.124-.05-4.685a1.6,1.6,0,0,0-1.094-.474,1.058,1.058,0,0,0-.772.31",
    transform: "translate(-761.799 -351.38)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.59,
    cy: 0.487,
    r: 0.347,
    gradientTransform: "translate(-732.135 102.819) rotate(180) scale(0.991 1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3502",
    "data-name": "Trazado 3502",
    d: "M757.292,353.244A2.241,2.241,0,1,0,760.3,351.5a1.785,1.785,0,0,0-.649-.12,2.7,2.7,0,0,0-2.363,1.863",
    transform: "translate(-757.076 -351.381)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.521,
    cy: 0.492,
    r: 0.361,
    gradientTransform: "matrix(0, -1, 0.964, 0, -356.734, -267.709)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3503",
    "data-name": "Trazado 3503",
    d: "M764.287,352.212a.942.942,0,1,0,1.185.105,1.017,1.017,0,0,0-.7-.3.673.673,0,0,0-.488.2",
    transform: "translate(-764.105 -352.016)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 0.515,
    cy: 0.487,
    r: 0.323,
    gradientTransform: "translate(-1717.916 235.647) rotate(180)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3505",
    "data-name": "Trazado 3505",
    d: "M758.2,379.951a87.757,87.757,0,0,1-8.914,15.778l1.687-.222a77.93,77.93,0,0,0,7.32-14.135c7.844-20.291,5.121-44.826,5.121-44.826s1.936,27.451-5.215,43.4",
    transform: "translate(-749.288 -336.547)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -36.498,
    y1: 18.578,
    x2: -36.449,
    y2: 18.578,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3506",
    "data-name": "Trazado 3506",
    d: "M756,335.767c-1.781.155-3.071,2.059-2.881,4.252s1.79,3.852,3.571,3.7,3.074-2.059,2.884-4.255c-.184-2.1-1.655-3.7-3.346-3.7q-.11,0-.228.009",
    transform: "translate(-753.097 -335.758)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 0.501,
    cy: 0.492,
    r: 0.419,
    gradientTransform: "matrix(1.155, 0, 0, -1, 45.42, 81.703)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3507",
    "data-name": "Trazado 3507",
    d: "M753.147,334.891a.788.788,0,0,0-.62.912,4.3,4.3,0,0,0,2.12,1.769c.38-.035-.693-1.415-.734-1.886a.8.8,0,0,0-.716-.8l-.05,0",
    transform: "translate(-752.523 -334.888)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 0.442,
    cy: 0.499,
    r: 0.419,
    gradientTransform: "matrix(1.058, 0, 0, -1, 45.882, 243.764)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3508",
    "data-name": "Trazado 3508",
    d: "M753.62,335.83a.48.48,0,1,0,.421.436.445.445,0,0,0-.395-.439l-.026,0",
    transform: "translate(-753.276 -335.827)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.497,
    cy: 0.492,
    r: 0.418,
    gradientTransform: "matrix(1.153, 0, 0, -1, 380.026, 692.117)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3518",
    "data-name": "Trazado 3518",
    d: "M717.31,340.147c-.412.091-1.471,2.6-1.366,3.065a.77.77,0,1,0,1.491-.333c-.1-.453.275-2.735-.1-2.735l-.023,0",
    transform: "translate(-715.937 -340.144)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 0.499,
    cy: 0.506,
    r: 0.378,
    gradientTransform: "matrix(1.558, 0, 0, -0.913, 438.503, 157.289)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_143",
    "data-name": "Rect\\xE1ngulo 143",
    width: 1364.821,
    height: 96.137,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3524",
    "data-name": "Trazado 3524",
    d: "M1729.326,400.363l-323.457-17.246,1.971,8.171,392.49,53.781L1056.1,389.557l-620.592,60.5,1304.86,29.193Z",
    transform: "translate(-435.509 -383.117)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.93,
    y1: 1.646,
    x2: -0.928,
    y2: 1.646,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-53"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_145",
    "data-name": "Rect\\xE1ngulo 145",
    width: 362.115,
    height: 60.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3525",
    "data-name": "Trazado 3525",
    d: "M824.891,367.921,767.3,412.364l351.858,16.457,10.257-30.451Z",
    transform: "translate(-767.299 -367.921)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -15.179,
    y1: 1.128,
    x2: -15.16,
    y2: 1.128,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_150",
    "data-name": "Rect\\xE1ngulo 150",
    width: 239.76,
    height: 15.37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-57"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3528",
    "data-name": "Trazado 3528",
    d: "M661.941,383.29l134.512-9.461L817.23,370.5l84.472-2.427-97.755-.152Z",
    transform: "translate(-661.941 -367.921)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -8.061,
    y1: 7.116,
    x2: -8.049,
    y2: 7.116,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_152",
    "data-name": "Rect\\xE1ngulo 152",
    width: 168.42,
    height: 7.069,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3529",
    "data-name": "Trazado 3529",
    d: "M583.178,370.759l102.385,7.069,66.035-1.164Z",
    transform: "translate(-583.178 -370.759)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -21.649,
    y1: 2.109,
    x2: -21.613,
    y2: 2.109,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3530",
    "data-name": "Trazado 3530",
    d: "M137.753,413.738v64.786h690.62l18.016-15.208H674.938l176.714-17.709s1.4-.682,3.9-1.886c7.768-3.67,26.064-12.476,46.858-22.68,4.875-2.407,9.911-4.908,14.98-7.408,36.008-17.94,73.54-37.47,74.157-41.3v-.1c0-6.92-63.529-13.029-63.529-13.029Z",
    transform: "translate(-137.753 -359.2)",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3586",
    "data-name": "Trazado 3586",
    d: "M354.74,409.194l79.3-7.946,39.377-19Z",
    transform: "translate(-354.74 -382.249)",
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3587",
    "data-name": "Trazado 3587",
    d: "M445.717,350.89l-14.424,11.523c35.379-4.238,48.534-18.121,48.534-18.121Z",
    transform: "translate(-431.293 -344.292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3588",
    "data-name": "Trazado 3588",
    d: "M525.294,375.553l4.849,23.23.959-18.858,43.974-23.871,40.12,4.258-42.249-9.651Z",
    transform: "translate(-525.294 -350.662)",
    fill: "#05020c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3589",
    "data-name": "Trazado 3589",
    d: "M562.378,333.432l-2.688,7.013,60.364.728L571.9,330.624Z",
    transform: "translate(-559.69 -330.624)",
    fill: "#05020c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_156",
    "data-name": "Rect\\xE1ngulo 156",
    width: 591.812,
    height: 72.042,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3531",
    "data-name": "Trazado 3531",
    d: "M926.37,355.075l12.447-5.2-26.55-4.744L785.338,340.16l-4.159-4.972L626.631,316.245c39.515,2.144,100.315,5.685,193.282,11.6,126.247,8.028,277.938,20.9,391.835,31.133l6.694,29.311Z",
    transform: "translate(-626.631 -316.245)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -3.161,
    y1: 1.902,
    x2: -3.156,
    y2: 1.902,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_157",
    "data-name": "Rect\\xE1ngulo 157",
    width: 895.789,
    height: 268.521,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_158",
    "data-name": "Rect\\xE1ngulo 158",
    width: 223.926,
    height: 66.205,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-70"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_159",
    "data-name": "Rect\\xE1ngulo 159",
    width: 907.726,
    height: 47.57,
    fill: "#9b9b9b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-71"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_160",
    "data-name": "Rect\\xE1ngulo 160",
    width: 887.906,
    height: 40.24,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-72"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_161",
    "data-name": "Rect\\xE1ngulo 161",
    width: 200.608,
    height: 29.647,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-73"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_172",
    "data-name": "Rect\\xE1ngulo 172",
    width: 1063.958,
    height: 230.234,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-74"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_163",
    "data-name": "Rect\\xE1ngulo 163",
    width: 37.339,
    height: 8.496,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3537",
    "data-name": "Trazado 3537",
    d: "M383.476,368.307c.164,2.223,8.651,3.41,18.96,2.656s18.533-3.164,18.373-5.387-8.651-3.41-18.96-2.656-18.536,3.167-18.372,5.387",
    transform: "translate(-383.473 -362.694)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -75.155,
    y1: 7.509,
    x2: -74.961,
    y2: 7.509,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7638f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b1057"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_165",
    "data-name": "Rect\\xE1ngulo 165",
    width: 51.421,
    height: 11.701,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-77"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3538",
    "data-name": "Trazado 3538",
    d: "M311.411,397.193c.225,3.059,11.915,4.7,26.114,3.659s25.523-4.361,25.3-7.42-11.915-4.7-26.114-3.659-25.523,4.361-25.3,7.42",
    transform: "translate(-311.408 -389.461)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -44.619,
    y1: 4.089,
    x2: -44.478,
    y2: 4.089,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-78"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_167",
    "data-name": "Rect\\xE1ngulo 167",
    width: 27.977,
    height: 6.367,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3539",
    "data-name": "Trazado 3539",
    d: "M368.439,373.221c.12,1.664,6.481,2.556,14.208,1.992s13.886-2.375,13.766-4.039-6.484-2.553-14.208-1.989-13.889,2.372-13.766,4.036",
    transform: "translate(-368.437 -369.015)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -96.165,
    y1: 9.253,
    x2: -95.906,
    y2: 9.253,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_169",
    "data-name": "Rect\\xE1ngulo 169",
    width: 39.892,
    height: 8.737,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3540",
    "data-name": "Trazado 3540",
    d: "M181.714,399.938c-.094,2.375,8.759,4.647,19.776,5.08s20.019-1.141,20.113-3.513-8.762-4.647-19.776-5.08-20.022,1.141-20.113,3.513",
    transform: "translate(-181.714 -396.354)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -27.741,
    y1: 4.689,
    x2: -27.591,
    y2: 4.689,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-82"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_171",
    "data-name": "Rect\\xE1ngulo 171",
    width: 29.89,
    height: 6.547,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3541",
    "data-name": "Trazado 3541",
    d: "M141.733,399.9c-.07,1.778,6.566,3.483,14.819,3.808s15-.854,15.071-2.632-6.563-3.483-14.819-3.808-15,.854-15.071,2.632",
    transform: "translate(-141.733 -397.218)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -28.851,
    y1: 6.044,
    x2: -28.651,
    y2: 6.044,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_199",
    "data-name": "Rect\\xE1ngulo 199",
    width: 683.427,
    height: 139.785,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-85"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 23.973,
    height: 5.278,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-86"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3542",
    "data-name": "Trazado 3542",
    d: "M174.847,357.709c-.064-1.427-5.484-2.343-12.1-2.047s-11.935,1.7-11.871,3.121,5.481,2.343,12.1,2.044,11.935-1.693,11.871-3.118",
    transform: "translate(-150.873 -355.606)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -45.097,
    y1: 12.356,
    x2: -44.803,
    y2: 12.356,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_176",
    "data-name": "Rect\\xE1ngulo 176",
    width: 33.019,
    height: 7.268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3543",
    "data-name": "Trazado 3543",
    d: "M216.636,345.654c-.091-1.962-7.551-3.226-16.667-2.816s-16.439,2.334-16.349,4.3,7.548,3.226,16.667,2.816,16.436-2.331,16.349-4.3",
    transform: "translate(-183.619 -342.761)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -39.931,
    y1: 10.181,
    x2: -39.718,
    y2: 10.181,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-89"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_178",
    "data-name": "Rect\\xE1ngulo 178",
    width: 17.966,
    height: 3.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-90"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3544",
    "data-name": "Trazado 3544",
    d: "M194.811,355.009c-.047-1.07-4.106-1.755-9.066-1.532s-8.944,1.269-8.9,2.337,4.109,1.755,9.069,1.533,8.944-1.269,8.894-2.337",
    transform: "translate(-176.848 -353.435)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -70.159,
    y1: 16.701,
    x2: -69.766,
    y2: 16.701,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-91"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_180",
    "data-name": "Rect\\xE1ngulo 180",
    width: 17.963,
    height: 3.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3545",
    "data-name": "Trazado 3545",
    d: "M216.967,343.551c-.047-1.067-4.109-1.752-9.069-1.53s-8.943,1.269-8.894,2.337,4.106,1.755,9.069,1.532,8.941-1.269,8.894-2.34",
    transform: "translate(-199.004 -341.98)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -78.86,
    y1: 18.508,
    x2: -78.467,
    y2: 18.508,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3546",
    "data-name": "Trazado 3546",
    d: "M260.492,352.063c-.047-1.07-4.109-1.755-9.069-1.533s-8.944,1.269-8.894,2.337,4.106,1.755,9.069,1.532,8.941-1.269,8.894-2.337",
    transform: "translate(-242.529 -350.489)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -95.954,
    y1: 17.165,
    x2: -95.561,
    y2: 17.165,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-95"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_184",
    "data-name": "Rect\\xE1ngulo 184",
    width: 33.016,
    height: 7.267,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-96"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3547",
    "data-name": "Trazado 3547",
    d: "M168.831,365.425c-.088-1.965-7.548-3.226-16.667-2.816s-16.436,2.331-16.349,4.3,7.551,3.226,16.667,2.816,16.436-2.334,16.349-4.3",
    transform: "translate(-135.814 -362.532)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -29.72,
    y1: 8.485,
    x2: -29.507,
    y2: 8.485,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-98"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3548",
    "data-name": "Trazado 3548",
    d: "M201.733,358.955c-.05-1.07-4.109-1.758-9.069-1.532s-8.943,1.266-8.894,2.337,4.106,1.755,9.066,1.533,8.943-1.269,8.9-2.337",
    transform: "translate(-183.77 -357.379)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -72.848,
    y1: 16.078,
    x2: -72.456,
    y2: 16.078,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3549",
    "data-name": "Trazado 3549",
    d: "M204.787,334.7c-.05-1.07-4.109-1.755-9.069-1.532s-8.943,1.269-8.894,2.337,4.106,1.755,9.066,1.533,8.943-1.269,8.9-2.337",
    transform: "translate(-186.824 -333.125)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -74.077,
    y1: 19.905,
    x2: -73.684,
    y2: 19.905,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_190",
    "data-name": "Rect\\xE1ngulo 190",
    width: 25.535,
    height: 5.767,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3550",
    "data-name": "Trazado 3550",
    d: "M247.122,364.822c.1-1.518-5.531-3.135-12.582-3.612s-12.851.369-12.953,1.889,5.531,3.135,12.582,3.612,12.851-.369,12.953-1.889",
    transform: "translate(-221.586 -361.078)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -48.246,
    y1: 10.952,
    x2: -48.03,
    y2: 10.952,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-103"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_192",
    "data-name": "Rect\\xE1ngulo 192",
    width: 35.171,
    height: 7.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3551",
    "data-name": "Trazado 3551",
    d: "M292.942,356.71c.143-2.091-7.616-4.32-17.325-4.975s-17.7.506-17.84,2.6,7.616,4.32,17.328,4.975,17.7-.509,17.837-2.6",
    transform: "translate(-257.774 -351.551)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -40.818,
    y1: 8.822,
    x2: -40.661,
    y2: 8.822,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_194",
    "data-name": "Rect\\xE1ngulo 194",
    width: 19.136,
    height: 4.321,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3552",
    "data-name": "Trazado 3552",
    d: "M268.54,364.573c.079-1.141-4.144-2.351-9.426-2.708s-9.631.275-9.707,1.413,4.144,2.351,9.429,2.708,9.628-.275,9.7-1.413",
    transform: "translate(-249.406 -361.765)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -72.262,
    y1: 14.383,
    x2: -71.974,
    y2: 14.383,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-107"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_196",
    "data-name": "Rect\\xE1ngulo 196",
    width: 19.136,
    height: 4.323,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3553",
    "data-name": "Trazado 3553",
    d: "M293.389,355.08c.076-1.138-4.144-2.349-9.429-2.708s-9.628.278-9.7,1.416,4.144,2.351,9.426,2.708,9.631-.278,9.707-1.415",
    transform: "translate(-274.255 -352.272)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -79.396,
    y1: 15.78,
    x2: -79.108,
    y2: 15.78,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3554",
    "data-name": "Trazado 3554",
    d: "M338.5,369.3c.079-1.138-4.144-2.348-9.426-2.705s-9.631.275-9.707,1.413,4.144,2.351,9.429,2.708,9.628-.275,9.7-1.415",
    transform: "translate(-319.364 -366.492)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -92.407,
    y1: 13.687,
    x2: -92.119,
    y2: 13.687,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-111"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_230",
    "data-name": "Rect\\xE1ngulo 230",
    width: 780.996,
    height: 150.188,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_201",
    "data-name": "Rect\\xE1ngulo 201",
    width: 25.757,
    height: 5.669,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3555",
    "data-name": "Trazado 3555",
    d: "M665.3,391.258c-.07-1.532-5.89-2.518-13-2.2s-12.825,1.819-12.754,3.352,5.89,2.515,13,2.2,12.822-1.819,12.754-3.352",
    transform: "translate(-639.544 -389.001)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -175.825,
    y1: 7.853,
    x2: -175.552,
    y2: 7.853,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_203",
    "data-name": "Rect\\xE1ngulo 203",
    width: 35.476,
    height: 7.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3556",
    "data-name": "Trazado 3556",
    d: "M710.2,378.309c-.093-2.112-8.11-3.466-17.907-3.027s-17.659,2.506-17.565,4.618,8.113,3.463,17.907,3.024,17.662-2.506,17.565-4.615",
    transform: "translate(-674.726 -375.2)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -134.885,
    y1: 6.912,
    x2: -134.686,
    y2: 6.912,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_205",
    "data-name": "Rect\\xE1ngulo 205",
    width: 19.302,
    height: 4.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3557",
    "data-name": "Trazado 3557",
    d: "M686.752,388.359c-.05-1.149-4.413-1.886-9.742-1.647s-9.607,1.363-9.558,2.512,4.413,1.887,9.745,1.647,9.607-1.363,9.555-2.512",
    transform: "translate(-667.452 -386.668)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -244.574,
    y1: 10.692,
    x2: -244.208,
    y2: 10.692,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_207",
    "data-name": "Rect\\xE1ngulo 207",
    width: 19.303,
    height: 4.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-119"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3558",
    "data-name": "Trazado 3558",
    d: "M710.559,376.051c-.053-1.146-4.416-1.883-9.745-1.646s-9.607,1.366-9.558,2.512,4.413,1.886,9.745,1.647,9.607-1.363,9.558-2.512",
    transform: "translate(-691.256 -374.36)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -253.362,
    y1: 12.499,
    x2: -252.996,
    y2: 12.499,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_209",
    "data-name": "Rect\\xE1ngulo 209",
    width: 19.3,
    height: 4.248,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3559",
    "data-name": "Trazado 3559",
    d: "M757.32,385.194c-.05-1.149-4.414-1.886-9.742-1.647s-9.61,1.363-9.558,2.512,4.413,1.883,9.742,1.647,9.61-1.366,9.558-2.512",
    transform: "translate(-738.02 -383.503)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -270.442,
    y1: 11.155,
    x2: -270.076,
    y2: 11.155,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_211",
    "data-name": "Rect\\xE1ngulo 211",
    width: 35.473,
    height: 7.808,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3560",
    "data-name": "Trazado 3560",
    d: "M658.838,399.549c-.1-2.109-8.113-3.466-17.908-3.024s-17.659,2.506-17.565,4.615,8.113,3.466,17.907,3.027,17.659-2.506,17.565-4.618",
    transform: "translate(-623.365 -396.442)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -124.651,
    y1: 5.216,
    x2: -124.452,
    y2: 5.216,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3561",
    "data-name": "Trazado 3561",
    d: "M694.189,392.6c-.053-1.146-4.413-1.886-9.745-1.647s-9.607,1.366-9.555,2.512,4.413,1.886,9.742,1.647,9.61-1.363,9.558-2.512",
    transform: "translate(-674.889 -390.906)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -247.28,
    y1: 10.068,
    x2: -246.914,
    y2: 10.068,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3562",
    "data-name": "Trazado 3562",
    d: "M697.47,366.538c-.053-1.149-4.413-1.886-9.742-1.647s-9.61,1.363-9.558,2.512,4.413,1.883,9.742,1.647,9.61-1.366,9.558-2.512",
    transform: "translate(-678.17 -364.846)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -248.562,
    y1: 13.894,
    x2: -248.196,
    y2: 13.894,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-128"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_217",
    "data-name": "Rect\\xE1ngulo 217",
    width: 27.439,
    height: 6.196,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-129"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3563",
    "data-name": "Trazado 3563",
    d: "M742.953,398.906c.111-1.632-5.94-3.372-13.518-3.884s-13.8.4-13.915,2.03,5.94,3.369,13.518,3.881,13.807-.395,13.915-2.027",
    transform: "translate(-715.518 -394.879)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -144.119,
    y1: 6.749,
    x2: -143.918,
    y2: 6.749,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-130"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_219",
    "data-name": "Rect\\xE1ngulo 219",
    width: 37.786,
    height: 8.533,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3564",
    "data-name": "Trazado 3564",
    d: "M792.186,390.187c.149-2.246-8.183-4.641-18.618-5.346s-19.013.547-19.165,2.793,8.183,4.644,18.615,5.349,19.016-.547,19.168-2.8",
    transform: "translate(-754.4 -384.644)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -110.431,
    y1: 5.771,
    x2: -110.285,
    y2: 5.771,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_221",
    "data-name": "Rect\\xE1ngulo 221",
    width: 20.557,
    height: 4.643,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3565",
    "data-name": "Trazado 3565",
    d: "M765.967,398.634c.082-1.222-4.451-2.527-10.128-2.91s-10.347.3-10.429,1.521,4.451,2.524,10.128,2.91,10.347-.3,10.429-1.521",
    transform: "translate(-745.409 -395.618)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -200.186,
    y1: 8.776,
    x2: -199.918,
    y2: 8.776,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_223",
    "data-name": "Rect\\xE1ngulo 223",
    width: 20.56,
    height: 4.643,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3566",
    "data-name": "Trazado 3566",
    d: "M792.667,388.434c.082-1.222-4.454-2.524-10.131-2.907s-10.344.3-10.429,1.518,4.454,2.527,10.131,2.91,10.344-.3,10.429-1.521",
    transform: "translate(-772.106 -385.419)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -207.378,
    y1: 10.173,
    x2: -207.11,
    y2: 10.173,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_225",
    "data-name": "Rect\\xE1ngulo 225",
    width: 33.317,
    height: 7.333,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3567",
    "data-name": "Trazado 3567",
    d: "M593.878,391.094c-.088-1.983-7.619-3.255-16.82-2.843s-16.585,2.354-16.5,4.337,7.622,3.252,16.82,2.84,16.586-2.354,16.5-4.334",
    transform: "translate(-560.56 -388.174)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -119.399,
    y1: 6.231,
    x2: -119.187,
    y2: 6.231,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-138"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_227",
    "data-name": "Rect\\xE1ngulo 227",
    width: 65.228,
    height: 14.73,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-139"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3568",
    "data-name": "Trazado 3568",
    d: "M654.059,399.713c.263-3.881-14.126-8.013-32.136-9.23s-32.823.942-33.083,4.823,14.123,8.013,32.136,9.23,32.82-.945,33.083-4.823",
    transform: "translate(-588.836 -390.144)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -50.177,
    y1: 3.27,
    x2: -50.092,
    y2: 3.27,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-140"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_229",
    "data-name": "Rect\\xE1ngulo 229",
    width: 35.49,
    height: 8.014,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3569",
    "data-name": "Trazado 3569",
    d: "M669.071,396.5c.143-2.112-7.686-4.358-17.483-5.021s-17.861.515-18,2.623,7.683,4.361,17.483,5.021,17.858-.512,18-2.623",
    transform: "translate(-633.584 -391.292)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -98.799,
    y1: 5.592,
    x2: -98.644,
    y2: 5.592,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-142"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_259",
    "data-name": "Rect\\xE1ngulo 259",
    width: 734.84,
    height: 148.093,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-143"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_232",
    "data-name": "Rect\\xE1ngulo 232",
    width: 25.754,
    height: 5.685,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-144"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3570",
    "data-name": "Trazado 3570",
    d: "M657.677,349.312c.073-1.532-5.633-3.05-12.746-3.393s-12.935.623-13.009,2.155,5.633,3.053,12.742,3.393,12.936-.623,13.012-2.155",
    transform: "translate(-631.922 -345.85)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -143.35,
    y1: 12.581,
    x2: -143.124,
    y2: 12.581,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-145"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_234",
    "data-name": "Rect\\xE1ngulo 234",
    width: 35.47,
    height: 7.832,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3571",
    "data-name": "Trazado 3571",
    d: "M703.659,340.284c.1-2.109-7.756-4.2-17.551-4.671s-17.817.86-17.916,2.968,7.756,4.2,17.548,4.674,17.817-.863,17.919-2.971",
    transform: "translate(-668.191 -335.519)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -110.193,
    y1: 10.068,
    x2: -110.029,
    y2: 10.068,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-147"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_236",
    "data-name": "Rect\\xE1ngulo 236",
    width: 19.3,
    height: 4.258,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3572",
    "data-name": "Trazado 3572",
    d: "M679.253,348.6c.055-1.149-4.22-2.287-9.549-2.542s-9.7.468-9.751,1.617,4.22,2.284,9.549,2.541,9.7-.468,9.751-1.617",
    transform: "translate(-659.953 -346.012)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -199.646,
    y1: 16.635,
    x2: -199.344,
    y2: 16.635,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3573",
    "data-name": "Trazado 3573",
    d: "M704.092,338.554c.055-1.149-4.22-2.287-9.549-2.541s-9.692.468-9.748,1.617,4.22,2.284,9.549,2.542,9.7-.468,9.748-1.617",
    transform: "translate(-684.795 -335.962)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -207.142,
    y1: 18.109,
    x2: -206.841,
    y2: 18.109,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-151"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_240",
    "data-name": "Rect\\xE1ngulo 240",
    width: 19.297,
    height: 4.261,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-152"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3574",
    "data-name": "Trazado 3574",
    d: "M749.808,351.988c.055-1.146-4.22-2.284-9.549-2.542s-9.692.468-9.748,1.617,4.22,2.287,9.549,2.541,9.692-.468,9.748-1.617",
    transform: "translate(-730.511 -349.396)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -220.938,
    y1: 16.139,
    x2: -220.636,
    y2: 16.139,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-153"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_242",
    "data-name": "Rect\\xE1ngulo 242",
    width: 25.754,
    height: 5.686,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3575",
    "data-name": "Trazado 3575",
    d: "M592.6,368.626c.073-1.532-5.633-3.05-12.745-3.393s-12.936.626-13.009,2.158,5.633,3.05,12.743,3.39,12.938-.623,13.012-2.155",
    transform: "translate(-566.843 -365.166)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -128.667,
    y1: 10.46,
    x2: -128.441,
    y2: 10.46,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-155"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_244",
    "data-name": "Rect\\xE1ngulo 244",
    width: 35.47,
    height: 7.829,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3576",
    "data-name": "Trazado 3576",
    d: "M650.553,356.677c.1-2.109-7.756-4.2-17.551-4.671s-17.817.86-17.919,2.969,7.759,4.2,17.551,4.674,17.817-.86,17.919-2.971",
    transform: "translate(-615.082 -351.912)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -101.475,
    y1: 8.76,
    x2: -101.31,
    y2: 8.76,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-157"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_246",
    "data-name": "Rect\\xE1ngulo 246",
    width: 19.3,
    height: 4.26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3577",
    "data-name": "Trazado 3577",
    d: "M599.117,365.313c.053-1.149-4.22-2.287-9.549-2.541s-9.7.468-9.751,1.614,4.22,2.287,9.549,2.541,9.7-.468,9.751-1.614",
    transform: "translate(-579.817 -362.719)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -175.428,
    y1: 14.188,
    x2: -175.126,
    y2: 14.188,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-159"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_248",
    "data-name": "Rect\\xE1ngulo 248",
    width: 19.3,
    height: 4.261,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3578",
    "data-name": "Trazado 3578",
    d: "M686.265,353.514c.052-1.149-4.22-2.287-9.549-2.542s-9.7.468-9.751,1.614,4.22,2.287,9.549,2.542,9.7-.468,9.751-1.614",
    transform: "translate(-666.965 -350.92)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -201.699,
    y1: 15.915,
    x2: -201.397,
    y2: 15.915,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-161"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_250",
    "data-name": "Rect\\xE1ngulo 250",
    width: 19.297,
    height: 4.258,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3579",
    "data-name": "Trazado 3579",
    d: "M691.943,327.869c.055-1.146-4.22-2.284-9.549-2.541s-9.692.468-9.748,1.617,4.22,2.284,9.549,2.542,9.692-.468,9.748-1.617",
    transform: "translate(-672.646 -325.277)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -203.476,
    y1: 19.675,
    x2: -203.174,
    y2: 19.675,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-163"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_252",
    "data-name": "Rect\\xE1ngulo 252",
    width: 27.161,
    height: 7.311,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3580",
    "data-name": "Trazado 3580",
    d: "M734.217,364.427c.26-1.614-5.606-3.9-13.1-5.115s-13.784-.886-14.044.731,5.6,3.9,13.1,5.115,13.784.886,14.047-.731",
    transform: "translate(-707.062 -358.578)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -115.02,
    y1: 10.363,
    x2: -114.858,
    y2: 10.363,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-165"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_254",
    "data-name": "Rect\\xE1ngulo 254",
    width: 37.406,
    height: 10.067,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-166"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3581",
    "data-name": "Trazado 3581",
    d: "M784.092,360.134c.36-2.226-7.718-5.381-18.039-7.048s-18.983-1.217-19.343,1.006,7.718,5.381,18.042,7.048,18.981,1.217,19.341-1.006",
    transform: "translate(-746.698 -352.079)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -88.269,
    y1: 8.107,
    x2: -88.151,
    y2: 8.107,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-167"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_256",
    "data-name": "Rect\\xE1ngulo 256",
    width: 20.352,
    height: 5.478,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3582",
    "data-name": "Trazado 3582",
    d: "M757.118,366.406c.2-1.211-4.2-2.928-9.815-3.834s-10.33-.664-10.523.547,4.2,2.928,9.815,3.834,10.327.661,10.523-.547",
    transform: "translate(-736.774 -362.022)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -159.881,
    y1: 13.24,
    x2: -159.664,
    y2: 13.24,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-170"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3583",
    "data-name": "Trazado 3583",
    d: "M784.648,358.724c.2-1.211-4.2-2.927-9.818-3.834s-10.327-.664-10.523.547,4.2,2.925,9.815,3.834,10.33.661,10.526-.547",
    transform: "translate(-764.301 -354.34)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -165.834,
    y1: 14.281,
    x2: -165.617,
    y2: 14.281,
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-171"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_260",
    "data-name": "Rect\\xE1ngulo 260",
    width: 571.599,
    height: 54.983,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-172"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_261",
    "data-name": "Rect\\xE1ngulo 261",
    width: 170.482,
    height: 28.679,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3523",
    "data-name": "Trazado 3523",
    d: "M690.109,308.032c-.79.363-1.837,5.87-1.427,6.756a1.584,1.584,0,1,0,2.857-1.313c-.392-.857-.623-5.463-1.348-5.463a.177.177,0,0,0-.082.021",
    transform: "translate(-688.59 -308.011)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 0.461,
    cy: 0.5,
    r: 0.363,
    gradientTransform: "matrix(1.323, 0, 0, -0.913, 96.899, 93.789)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3522",
    "data-name": "Trazado 3522",
    d: "M684.686,312.244a1.781,1.781,0,1,0,2.2-.892,1.982,1.982,0,0,0-.655-.114,1.594,1.594,0,0,0-1.541,1.006",
    transform: "translate(-684.604 -311.238)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 0.522,
    cy: 0.493,
    r: 0.365,
    gradientTransform: "matrix(-1.069, 0, 0, 0.913, -914.832, 7.687)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3521",
    "data-name": "Trazado 3521",
    d: "M684.382,310.6a4.144,4.144,0,1,0,5.106-2.065,4.587,4.587,0,0,0-1.532-.269,3.692,3.692,0,0,0-3.574,2.334",
    transform: "translate(-684.189 -308.271)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.522,
    cy: 0.493,
    r: 0.365,
    gradientTransform: "matrix(-1.068, 0, 0, 0.913, -392.78, 3.382)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-176"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3519",
    "data-name": "Trazado 3519",
    d: "M723.749,460.455a375.483,375.483,0,0,1-5.068,39.553l4.057-.427a269.673,269.673,0,0,0,3.135-34.256c2.009-81.111-38.421-163.84-38.421-163.84s41.322,93.956,36.3,158.971",
    transform: "translate(-687.452 -301.484)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -19.232,
    y1: 2.266,
    x2: -19.203,
    y2: 2.266,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-177"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3509",
    "data-name": "Trazado 3509",
    d: "M709.515,446.117l1.392-.146C709.9,387.6,682.021,330.559,682.021,330.559s29.442,66.945,27.494,115.558",
    transform: "translate(-682.021 -330.559)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -30.402,
    y1: 3.125,
    x2: -30.357,
    y2: 3.125,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3491",
    "data-name": "Trazado 3491",
    d: "M675.9,339.069a2.217,2.217,0,0,0-.772,3c.553,1.205,6.282,3.112,7.262,2.661s-3.161-3.086-3.714-4.29a2.432,2.432,0,0,0-2.091-1.515,1.646,1.646,0,0,0-.684.146",
    transform: "translate(-674.869 -338.923)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 0.441,
    cy: 0.493,
    r: 0.368,
    gradientTransform: "matrix(0.883, 0, 0, -1, -21.835, 74.035)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-179"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3490",
    "data-name": "Trazado 3490",
    d: "M682.783,340.446c-4.556,2.094-6.159,8.338-3.586,13.948s8.361,8.464,12.915,6.37,6.159-8.335,3.586-13.945c-2-4.363-5.946-7.057-9.739-7.057a7.576,7.576,0,0,0-3.176.684",
    transform: "translate(-677.969 -339.762)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.51,
    cy: 0.479,
    r: 0.339,
    gradientTransform: "matrix(1.024, 0, 0, -1, 1.638, 23.033)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3510",
    "data-name": "Trazado 3510",
    d: "M685.831,327.728c-5.68,2.609-7.911,9.9-4.975,16.29s9.915,9.452,15.594,6.844,7.911-9.9,4.978-16.29A12.818,12.818,0,0,0,690.11,326.8a10.252,10.252,0,0,0-4.279.93",
    transform: "translate(-679.563 -326.798)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 0.51,
    cy: 0.478,
    r: 0.36,
    gradientTransform: "matrix(1.003, 0, 0, -0.913, 0.182, 20.854)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3512",
    "data-name": "Trazado 3512",
    d: "M688.368,326.635a1.338,1.338,0,1,0,1.629.717,1.33,1.33,0,0,0-1.181-.813,1.1,1.1,0,0,0-.448.1",
    transform: "translate(-687.715 -326.538)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 0.51,
    cy: 0.478,
    r: 0.36,
    gradientTransform: "matrix(1.004, 0, 0, -0.913, 1.926, 198.022)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3513",
    "data-name": "Trazado 3513",
    d: "M684.019,335.478c-.594.272-1.38,4.41-1.076,5.077a1.192,1.192,0,1,0,2.152-.989c-.3-.64-.471-4.1-1.012-4.1a.184.184,0,0,0-.065.015",
    transform: "translate(-682.875 -335.463)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 0.461,
    cy: 0.5,
    r: 0.363,
    gradientTransform: "matrix(1.323, 0, 0, -0.913, 127.87, 101.795)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3511",
    "data-name": "Trazado 3511",
    d: "M687.284,327.147a3.113,3.113,0,1,0,3.79,1.664,3.11,3.11,0,0,0-2.749-1.892,2.47,2.47,0,0,0-1.041.228",
    transform: "translate(-685.762 -326.919)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 0.51,
    cy: 0.479,
    r: 0.36,
    gradientTransform: "matrix(1.003, 0, 0, -0.913, 0.746, 85.016)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3495",
    "data-name": "Trazado 3495",
    d: "M728.7,344.4c-.36.936-3.343,3.126-2.585,3.416s4.981-1.43,5.337-2.366a1.667,1.667,0,0,0-.728-2.22,1.262,1.262,0,0,0-.439-.079A1.809,1.809,0,0,0,728.7,344.4",
    transform: "translate(-725.987 -343.155)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 0.506,
    cy: 0.557,
    r: 0.333,
    gradientTransform: "matrix(0, -1, 1.125, 0, -354.29, -263.337)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3494",
    "data-name": "Trazado 3494",
    d: "M721.571,349.861c-1.661,4.355-.143,8.982,3.4,10.33s7.747-1.088,9.411-5.443.143-8.982-3.4-10.333a5.675,5.675,0,0,0-2.03-.371c-2.992,0-6.03,2.275-7.382,5.817",
    transform: "translate(-720.898 -344.044)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 0.521,
    cy: 0.492,
    r: 0.361,
    gradientTransform: "matrix(0, -1, 0.964, 0, -110.237, -79.662)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3517",
    "data-name": "Trazado 3517",
    d: "M720.949,335.156a.868.868,0,1,0,.936.673.842.842,0,0,0-.784-.69.7.7,0,0,0-.152.018",
    transform: "translate(-720.367 -335.138)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 0.504,
    cy: 0.483,
    r: 0.405,
    gradientTransform: "matrix(1.032, 0, 0, -0.913, 33.323, 321.416)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3516",
    "data-name": "Trazado 3516",
    d: "M720.354,335.214a2.016,2.016,0,1,0,2.173,1.568,1.961,1.961,0,0,0-1.825-1.606,1.737,1.737,0,0,0-.348.038",
    transform: "translate(-718.997 -335.176)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 0.504,
    cy: 0.483,
    r: 0.405,
    gradientTransform: "matrix(1.032, 0, 0, -0.913, 14.103, 138.258)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3514",
    "data-name": "Trazado 3514",
    d: "M719.4,416.155c-1.342,4.539-2.737,8.7-4.153,12.5l1.831-.018c1.07-3.258,2.027-6.577,2.834-9.955,9.195-38.368-1.635-81.816-1.635-81.816s10.113,48.876,1.123,79.286",
    transform: "translate(-715.245 -336.869)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -85.263,
    y1: 3.793,
    x2: -85.143,
    y2: 3.793,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3515",
    "data-name": "Trazado 3515",
    d: "M720.218,334.753c-3.948.883-6.346,5.2-5.352,9.637s5,7.323,8.946,6.443,6.347-5.2,5.355-9.64c-.874-3.9-4.074-6.6-7.516-6.6a6.479,6.479,0,0,0-1.433.161",
    transform: "translate(-714.641 -334.592)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 0.504,
    cy: 0.483,
    r: 0.406,
    gradientTransform: "matrix(1.032, 0, 0, -0.913, 3.418, 33.883)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-190"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3499",
    "data-name": "Trazado 3499",
    d: "M752.74,341.373c-.266.7-2.492,2.328-1.925,2.544s3.706-1.065,3.972-1.761a1.242,1.242,0,0,0-.544-1.655.951.951,0,0,0-.325-.059,1.347,1.347,0,0,0-1.178.93",
    transform: "translate(-750.723 -340.443)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 0.506,
    cy: 0.558,
    r: 0.333,
    gradientTransform: "matrix(0, -1, 1.125, 0, -491.289, -366.391)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3497",
    "data-name": "Trazado 3497",
    d: "M745.359,386.021l.43-.055c2.778-22.166,10.558-43.589,10.558-43.589a189.612,189.612,0,0,0-10.988,43.644",
    transform: "translate(-745.359 -342.377)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -48.063,
    y1: 14.823,
    x2: -47.998,
    y2: 14.823,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-192"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3498",
    "data-name": "Trazado 3498",
    d: "M747.437,345.434c-1.237,3.241-.105,6.683,2.527,7.686s5.767-.81,7-4.051.105-6.686-2.527-7.689a4.238,4.238,0,0,0-1.512-.275,6.271,6.271,0,0,0-5.492,4.328",
    transform: "translate(-746.936 -341.106)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 0.521,
    cy: 0.492,
    r: 0.361,
    gradientTransform: "matrix(0, -1, 0.964, 0, -153.32, -111.232)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3504",
    "data-name": "Trazado 3504",
    d: "M748.6,354.9c-.845,2.217-.07,4.571,1.729,5.256s3.943-.553,4.788-2.77.073-4.568-1.726-5.256a2.882,2.882,0,0,0-1.035-.19,4.3,4.3,0,0,0-3.755,2.96",
    transform: "translate(-748.261 -351.941)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 0.521,
    cy: 0.492,
    r: 0.361,
    gradientTransform: "matrix(0, -1, 0.964, 0, -221.825, -166.084)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3520",
    "data-name": "Trazado 3520",
    d: "M690.907,297.717c-7.563,3.472-10.529,13.181-6.627,21.683s13.2,12.579,20.765,9.107,10.529-13.178,6.624-21.683c-2.96-6.446-9.016-10.347-15.068-10.347a13.558,13.558,0,0,0-5.694,1.24",
    transform: "translate(-682.561 -296.477)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 0.51,
    cy: 0.478,
    r: 0.36,
    gradientTransform: "matrix(1.003, 0, 0, -0.913, 0.137, 19.338)",
    xlinkHref: "#radial-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_835",
    "data-name": "Grupo 835",
    transform: "translate(-8050 -10514.141)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_111",
    "data-name": "Grupo 111",
    transform: "translate(8452.875 11401.59)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_110",
    "data-name": "Grupo 110",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_66",
    "data-name": "Rect\\xE1ngulo 66",
    width: 1235.934,
    height: 307.789,
    transform: "translate(-5.84 0.121) rotate(-1.185)",
    fill: "#000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_113",
    "data-name": "Grupo 113",
    transform: "translate(8990.061 11407.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_112",
    "data-name": "Grupo 112",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_67",
    "data-name": "Rect\\xE1ngulo 67",
    width: 359.485,
    height: 746.131,
    transform: "translate(-32.57 272.187) rotate(-83.176)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_130",
    "data-name": "Grupo 130",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_129",
    "data-name": "Grupo 129",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_118",
    "data-name": "Grupo 118",
    transform: "translate(896.393 970.12)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_117",
    "data-name": "Grupo 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Enmascarar_grupo_116",
    "data-name": "Enmascarar grupo 116",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_115",
    "data-name": "Grupo 115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_114",
    "data-name": "Grupo 114",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_68",
    "data-name": "Rect\\xE1ngulo 68",
    width: 297.005,
    height: 251.064,
    transform: "translate(-46.995 255.296) rotate(-79.57)",
    fill: "#9b9b9b"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_123",
    "data-name": "Grupo 123",
    transform: "translate(548.077 1154.649)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_122",
    "data-name": "Grupo 122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_121",
    "data-name": "Grupo 121",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_120",
    "data-name": "Grupo 120",
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_119",
    "data-name": "Grupo 119",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_70",
    "data-name": "Rect\\xE1ngulo 70",
    width: 211.548,
    height: 223.945,
    transform: "translate(-56.561 19.193) rotate(-18.987)",
    fill: "url(#linear-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_128",
    "data-name": "Grupo 128",
    transform: "translate(160.331 944.117)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_127",
    "data-name": "Grupo 127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_126",
    "data-name": "Grupo 126",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_125",
    "data-name": "Grupo 125",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_124",
    "data-name": "Grupo 124",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_72",
    "data-name": "Rect\\xE1ngulo 72",
    width: 579.059,
    height: 278.05,
    transform: "translate(-20.695 8.26) rotate(-21.758)",
    fill: "url(#linear-gradient-2)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_148",
    "data-name": "Grupo 148",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_147",
    "data-name": "Grupo 147",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_146",
    "data-name": "Grupo 146",
    transform: "translate(790.279 932.436)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_145",
    "data-name": "Grupo 145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_144",
    "data-name": "Grupo 144",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_143",
    "data-name": "Grupo 143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_142",
    "data-name": "Grupo 142",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_80",
    "data-name": "Rect\\xE1ngulo 80",
    width: 77.207,
    height: 162.434,
    transform: "translate(-6.918 18.747) rotate(-69.744)",
    fill: "url(#linear-gradient-3)"
  }))))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_152",
    "data-name": "Grupo 152",
    transform: "translate(8992.675 11643.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_151",
    "data-name": "Grupo 151",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13048",
    "data-name": "Trazado 13048",
    d: "M0,0H162.552V140.052L132.64,147.8,0,140.052Z",
    transform: "matrix(0.781, -0.625, 0.625, 0.781, -17.371, 13.897)",
    fill: "#9b9b9b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_159",
    "data-name": "Grupo 159",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_158",
    "data-name": "Grupo 158",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_157",
    "data-name": "Grupo 157",
    transform: "translate(714.941 1063.65)",
    style: {
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_156",
    "data-name": "Grupo 156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_155",
    "data-name": "Grupo 155",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_154",
    "data-name": "Grupo 154",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_153",
    "data-name": "Grupo 153",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_85",
    "data-name": "Rect\\xE1ngulo 85",
    width: 199.073,
    height: 168.565,
    transform: "translate(-31.489 171.064) rotate(-79.57)",
    fill: "#9b9b9b"
  }))))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_161",
    "data-name": "Grupo 161",
    transform: "translate(9288.346 11435.853)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_160",
    "data-name": "Grupo 160",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_88",
    "data-name": "Rect\\xE1ngulo 88",
    width: 1119.169,
    height: 271.133,
    transform: "matrix(1, -0.021, 0.021, 1, -5.132, 0.106)",
    fill: "#000"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163",
    "data-name": "Grupo 163",
    transform: "translate(9588.914 11545.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162",
    "data-name": "Grupo 162",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_89",
    "data-name": "Rect\\xE1ngulo 89",
    width: 706.882,
    height: 319.207,
    transform: "matrix(0.934, -0.357, 0.357, 0.934, -20.369, 7.797)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_190",
    "data-name": "Grupo 190",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_189",
    "data-name": "Grupo 189",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_168",
    "data-name": "Grupo 168",
    transform: "translate(1265.027 1061.475)",
    style: {
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_167",
    "data-name": "Grupo 167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_166",
    "data-name": "Grupo 166",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165",
    "data-name": "Grupo 165",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164",
    "data-name": "Grupo 164",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_90",
    "data-name": "Rect\\xE1ngulo 90",
    width: 90.056,
    height: 33.694,
    transform: "translate(-2.602 0.281) rotate(-6.157)",
    fill: "#9b9b9b"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_173",
    "data-name": "Grupo 173",
    transform: "translate(1400.44 1063.558)",
    style: {
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_172",
    "data-name": "Grupo 172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_171",
    "data-name": "Grupo 171",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_170",
    "data-name": "Grupo 170",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_169",
    "data-name": "Grupo 169",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_92",
    "data-name": "Rect\\xE1ngulo 92",
    width: 32.549,
    height: 28.02,
    transform: "translate(-2.66 0.287) rotate(-6.157)",
    fill: "#9b9b9b"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_178",
    "data-name": "Grupo 178",
    transform: "translate(1436.725 1066.972)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_177",
    "data-name": "Grupo 177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_176",
    "data-name": "Grupo 176",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_94",
    "data-name": "Rect\\xE1ngulo 94",
    width: 7.511,
    height: 22.336,
    transform: "translate(-2.336 0.252) rotate(-6.157)",
    fill: "url(#linear-gradient-4)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_183",
    "data-name": "Grupo 183",
    transform: "translate(1236.693 936.495)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_182",
    "data-name": "Grupo 182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_181",
    "data-name": "Grupo 181",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_180",
    "data-name": "Grupo 180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_179",
    "data-name": "Grupo 179",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 266.225,
    height: 299.811,
    transform: "matrix(0.643, -0.766, 0.766, 0.643, -32.005, 38.16)",
    fill: "url(#linear-gradient-5)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_188",
    "data-name": "Grupo 188",
    transform: "translate(943.813 1078.609)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_187",
    "data-name": "Grupo 187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_186",
    "data-name": "Grupo 186",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_185",
    "data-name": "Grupo 185",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_184",
    "data-name": "Grupo 184",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_98",
    "data-name": "Rect\\xE1ngulo 98",
    width: 391.296,
    height: 455.203,
    transform: "translate(-20.612 24.576) rotate(-50.013)",
    fill: "url(#linear-gradient-6)"
  }))))))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192",
    transform: "translate(9893.602 11477.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_101",
    "data-name": "Rect\\xE1ngulo 101",
    width: 69.969,
    height: 129.509,
    transform: "matrix(0.947, -0.321, 0.321, 0.947, -38.422, 13.042)",
    fill: "url(#linear-gradient-7)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    transform: "translate(9882.963 11463.586)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_102",
    "data-name": "Rect\\xE1ngulo 102",
    width: 38.242,
    height: 39.168,
    transform: "translate(-13.185 5.246) rotate(-24.664)",
    fill: "url(#radial-gradient)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196",
    transform: "translate(9892.195 11452.678)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_103",
    "data-name": "Rect\\xE1ngulo 103",
    width: 10.021,
    height: 12.341,
    transform: "translate(-4.47 1.879) rotate(-24.664)",
    fill: "url(#radial-gradient-2)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    transform: "translate(9887.437 11493.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_104",
    "data-name": "Rect\\xE1ngulo 104",
    width: 3.45,
    height: 3.535,
    transform: "translate(-1.19 0.474) rotate(-24.664)",
    fill: "url(#radial-gradient-3)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_200",
    "data-name": "Grupo 200",
    transform: "translate(9905.992 11485.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_105",
    "data-name": "Rect\\xE1ngulo 105",
    width: 8.017,
    height: 7.224,
    transform: "translate(-2.34 0.86) rotate(-24.664)",
    fill: "url(#radial-gradient-4)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_202",
    "data-name": "Grupo 202",
    transform: "translate(9908.606 11481.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_106",
    "data-name": "Rect\\xE1ngulo 106",
    width: 2.472,
    height: 2.534,
    transform: "matrix(0.909, -0.417, 0.417, 0.909, -0.853, 0.34)",
    fill: "url(#radial-gradient-5)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204",
    transform: "translate(10040.025 11514.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_107",
    "data-name": "Rect\\xE1ngulo 107",
    width: 50.998,
    height: 86.621,
    transform: "translate(-25.18 8.547) rotate(-18.75)",
    fill: "url(#linear-gradient-8)"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_210",
    "data-name": "Grupo 210",
    transform: "translate(10031.874 11510.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_209",
    "data-name": "Grupo 209",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_110",
    "data-name": "Rect\\xE1ngulo 110",
    width: 3.453,
    height: 3.536,
    transform: "translate(-1.192 0.474) rotate(-24.663)",
    fill: "url(#radial-gradient-6)"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(10151.412 11525.337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_211",
    "data-name": "Grupo 211",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_111",
    "data-name": "Rect\\xE1ngulo 111",
    width: 67.486,
    height: 31.958,
    transform: "translate(-16.399 61.325) rotate(-75.029)",
    fill: "url(#linear-gradient-9)"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218",
    transform: "translate(10171.271 11522.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_114",
    "data-name": "Rect\\xE1ngulo 114",
    width: 2.601,
    height: 2.51,
    transform: "matrix(0.357, -0.934, 0.934, 0.357, -0.802, 1.797)",
    fill: "url(#radial-gradient-7)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226",
    transform: "translate(10244.119 11513.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_225",
    "data-name": "Grupo 225",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_118",
    "data-name": "Rect\\xE1ngulo 118",
    width: 1.933,
    height: 1.865,
    transform: "translate(-0.596 1.335) rotate(-69.116)",
    fill: "url(#radial-gradient-8)"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_228",
    "data-name": "Grupo 228",
    transform: "translate(10277.971 11541.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_227",
    "data-name": "Grupo 227",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_119",
    "data-name": "Rect\\xE1ngulo 119",
    width: 6.054,
    height: 6.001,
    transform: "matrix(0.697, -0.717, 0.717, 0.697, -2.981, 2.892)",
    fill: "url(#radial-gradient-9)"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_230",
    "data-name": "Grupo 230",
    transform: "translate(10264.16 11541.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_229",
    "data-name": "Grupo 229",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_120",
    "data-name": "Rect\\xE1ngulo 120",
    width: 7.069,
    height: 6.816,
    transform: "matrix(0.356, -0.934, 0.934, 0.356, -2.182, 4.886)",
    fill: "url(#radial-gradient-10)"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_232",
    "data-name": "Grupo 232",
    transform: "translate(10284.715 11543.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_231",
    "data-name": "Grupo 231",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_121",
    "data-name": "Rect\\xE1ngulo 121",
    width: 2.602,
    height: 2.604,
    transform: "matrix(0.697, -0.717, 0.717, 0.697, -0.997, 0.915)",
    fill: "url(#radial-gradient-11)"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_236",
    "data-name": "Grupo 236",
    transform: "translate(10241.383 11498.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_235",
    "data-name": "Grupo 235",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_123",
    "data-name": "Rect\\xE1ngulo 123",
    width: 59.457,
    height: 17.843,
    transform: "translate(-0.994 59.166) rotate(-89.037)",
    fill: "url(#linear-gradient-10)"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_238",
    "data-name": "Grupo 238",
    transform: "translate(10252.521 11496.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_237",
    "data-name": "Grupo 237",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_124",
    "data-name": "Rect\\xE1ngulo 124",
    width: 7.509,
    height: 8.672,
    transform: "translate(-0.869 0.06) rotate(-4.95)",
    fill: "url(#radial-gradient-12)"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_240",
    "data-name": "Grupo 240",
    transform: "translate(10250.843 11493.561)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_239",
    "data-name": "Grupo 239",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_125",
    "data-name": "Rect\\xE1ngulo 125",
    width: 2.767,
    height: 2.926,
    transform: "matrix(0.996, -0.086, 0.086, 0.996, -0.271, 0.02)",
    fill: "url(#radial-gradient-13)"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_242",
    "data-name": "Grupo 242",
    transform: "translate(10253.047 11496.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_241",
    "data-name": "Grupo 241",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_126",
    "data-name": "Rect\\xE1ngulo 126",
    width: 0.887,
    height: 1.022,
    transform: "matrix(0.996, -0.086, 0.086, 0.996, -0.101, 0.007)",
    fill: "url(#radial-gradient-14)"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_262",
    "data-name": "Grupo 262",
    transform: "translate(10143.842 11508.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_136",
    "data-name": "Rect\\xE1ngulo 136",
    width: 2.664,
    height: 4.15,
    transform: "translate(-0.915 0.183) rotate(-12.609)",
    fill: "url(#radial-gradient-15)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_284",
    "data-name": "Grupo 284",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_283",
    "data-name": "Grupo 283",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_277",
    "data-name": "Grupo 277",
    transform: "translate(870.823 1120.472)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_276",
    "data-name": "Grupo 276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_275",
    "data-name": "Grupo 275",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_274",
    "data-name": "Grupo 274",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_273",
    "data-name": "Grupo 273",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_142",
    "data-name": "Rect\\xE1ngulo 142",
    width: 1367.43,
    height: 146.19,
    transform: "translate(-3.528 0.13) rotate(-2.104)",
    fill: "url(#linear-gradient-11)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_282",
    "data-name": "Grupo 282",
    transform: "translate(1841.183 1076.028)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_281",
    "data-name": "Grupo 281"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_280",
    "data-name": "Grupo 280",
    clipPath: "url(#clip-path-53)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_279",
    "data-name": "Grupo 279",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_278",
    "data-name": "Grupo 278",
    clipPath: "url(#clip-path-54)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_144",
    "data-name": "Rect\\xE1ngulo 144",
    width: 154.678,
    height: 365.308,
    transform: "matrix(0.265, -0.964, 0.964, 0.265, -15.561, 56.623)",
    fill: "url(#linear-gradient-12)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_300",
    "data-name": "Grupo 300",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_299",
    "data-name": "Grupo 299",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_293",
    "data-name": "Grupo 293",
    transform: "translate(1533.051 1076.028)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_292",
    "data-name": "Grupo 292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_291",
    "data-name": "Grupo 291",
    clipPath: "url(#clip-path-56)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_290",
    "data-name": "Grupo 290",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_289",
    "data-name": "Grupo 289",
    clipPath: "url(#clip-path-57)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_149",
    "data-name": "Rect\\xE1ngulo 149",
    width: 240.135,
    height: 38.128,
    transform: "translate(-1.457 0.139) rotate(-5.464)",
    fill: "url(#linear-gradient-13)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_298",
    "data-name": "Grupo 298",
    transform: "translate(1302.699 1084.329)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_297",
    "data-name": "Grupo 297"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_296",
    "data-name": "Grupo 296",
    clipPath: "url(#clip-path-58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_295",
    "data-name": "Grupo 295"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_294",
    "data-name": "Grupo 294",
    clipPath: "url(#clip-path-59)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_151",
    "data-name": "Rect\\xE1ngulo 151",
    width: 80.808,
    height: 154.188,
    transform: "matrix(0.442, -0.897, 0.897, 0.442, -2.803, 5.687)",
    fill: "url(#linear-gradient-14)"
  }))))))))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_302",
    "data-name": "Grupo 302",
    transform: "translate(8452.875 11564.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_301",
    "data-name": "Grupo 301",
    clipPath: "url(#clip-path-60)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_154",
    "data-name": "Rect\\xE1ngulo 154",
    width: 201.461,
    height: 861.336,
    transform: "translate(-11.503 118.205) rotate(-84.442)",
    fill: "#000"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_579",
    "data-name": "Grupo 579",
    transform: "translate(9087.479 11632.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_578",
    "data-name": "Grupo 578",
    clipPath: "url(#clip-path-61)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_263",
    "data-name": "Rect\\xE1ngulo 263",
    width: 120.35,
    height: 35.709,
    transform: "translate(-2.001 0.149) rotate(-4.271)",
    fill: "#9b9b9b"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_581",
    "data-name": "Grupo 581",
    transform: "translate(9311.368 11515.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_580",
    "data-name": "Grupo 580",
    clipPath: "url(#clip-path-62)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_264",
    "data-name": "Rect\\xE1ngulo 264",
    width: 49.749,
    height: 21.685,
    transform: "matrix(0.997, -0.074, 0.074, 0.997, -1.346, 0.101)",
    fill: "#fff"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_583",
    "data-name": "Grupo 583",
    transform: "translate(9586.285 11539.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_582",
    "data-name": "Grupo 582",
    clipPath: "url(#clip-path-63)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_265",
    "data-name": "Rect\\xE1ngulo 265",
    width: 99.029,
    height: 68.914,
    transform: "translate(-11.562 2.96) rotate(-14.359)",
    fill: "#05020c"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_585",
    "data-name": "Grupo 585",
    transform: "translate(9686.881 11481.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_584",
    "data-name": "Grupo 584",
    clipPath: "url(#clip-path-64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_266",
    "data-name": "Rect\\xE1ngulo 266",
    width: 61.229,
    height: 23.097,
    transform: "translate(-2.184 0.473) rotate(-12.229)",
    fill: "#05020c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_577",
    "data-name": "Grupo 577",
    transform: "translate(8452.875 10514.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_576",
    "data-name": "Grupo 576",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_307",
    "data-name": "Grupo 307",
    transform: "translate(1429.782 924.896)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_306",
    "data-name": "Grupo 306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_305",
    "data-name": "Grupo 305",
    clipPath: "url(#clip-path-66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_304",
    "data-name": "Grupo 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_303",
    "data-name": "Grupo 303",
    clipPath: "url(#clip-path-67)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_155",
    "data-name": "Rect\\xE1ngulo 155",
    width: 581.407,
    height: 267.53,
    transform: "matrix(0.941, -0.337, 0.337, 0.941, -22.885, 8.204)",
    fill: "url(#linear-gradient-15)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_310",
    "data-name": "Grupo 310",
    transform: "translate(-140.859 1050.524)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_309",
    "data-name": "Grupo 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_308",
    "data-name": "Grupo 308",
    clipPath: "url(#clip-path-68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3532",
    "data-name": "Trazado 3532",
    d: "M89.59,626.969S465.178,472.1,479.559,453.288s40.018-26.354,40.018-26.354l181.347-45.665,16.861-1.164s-117.643,40.094-127.6,53.319S428.03,561.7,416.185,569.445s-35.081,35.4-35.081,35.4l138.472,6.8S740.125,448.065,747.015,439.06,969.292,359.2,969.292,359.2l16.085,2.439s-214.272,63.537-215.129,71.785-44,74.625-44,74.625L607.309,627.721Z",
    transform: "translate(-89.589 -359.201)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_313",
    "data-name": "Grupo 313",
    transform: "translate(127.01 1081.727)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_312",
    "data-name": "Grupo 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_311",
    "data-name": "Grupo 311",
    clipPath: "url(#clip-path-69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3533",
    "data-name": "Trazado 3533",
    d: "M405.107,369.869s-46.376,12.567-54.673,13.664-94.585,37.391-94.585,37.391l-74.669,15.15s67.2-23.134,77.16-27.331,49.862-32.955,84.27-35.329,62.5-3.545,62.5-3.545",
    transform: "translate(-181.181 -369.87)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_316",
    "data-name": "Grupo 316",
    transform: "translate(1181.061 999.141)",
    style: {
      isolation: "isolate"
    }
  }, _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_315",
    "data-name": "Grupo 315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_314",
    "data-name": "Grupo 314",
    clipPath: "url(#clip-path-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3534",
    "data-name": "Trazado 3534",
    d: "M541.587,371.955c1.24-.717,111.472,17.8,126.01,11.157s112.572-16.588,129.654-16.588,119.406,1.105,144.295,2.208,77.991-11.233,84.63-12.8,280.43,11.146,280.43,11.146L1441.4,389.2l7.914-26.4s-292.731-10.891-332.977-12.313-98.682-8.818-106.2-8.85S879.825,360.6,825.784,359.414s-125.174,18.168-156.26,16.509-107.79-16.509-107.79-16.509Z",
    transform: "translate(-541.587 -341.629)",
    fill: "#9b9b9b",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_319",
    "data-name": "Grupo 319",
    transform: "translate(27.977 887.45)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_318",
    "data-name": "Grupo 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_317",
    "data-name": "Grupo 317",
    clipPath: "url(#clip-path-71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3535",
    "data-name": "Trazado 3535",
    d: "M1035.225,303.883c-64.33-.266-212.8,10.189-234.87,15.234-22.78,5.2-166.411,5.393-166.411,5.393l2.211,3.413L554.3,329.742s-198.029,9.619-214.6,7.961c-12.772-1.266-135.93,3.641-192.376,5.981q27.98-3.167,58.364-5.981c345.026-31.811,642.773-35.868,829.542-33.82",
    transform: "translate(-147.319 -303.441)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_322",
    "data-name": "Grupo 322",
    transform: "translate(922.478 887.97)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_321",
    "data-name": "Grupo 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_320",
    "data-name": "Grupo 320",
    clipPath: "url(#clip-path-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3536",
    "data-name": "Trazado 3536",
    d: "M653.779,309.415l-90.663,23.853-21.122-5.688h-13.81l37.6-8.806s-52.222-14.023-112.609-15.155c121.951,1.453,194.923,5.469,200.284,5.764Z",
    transform: "translate(-453.171 -303.621)",
    fill: "#c49fa4",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_350",
    "data-name": "Grupo 350",
    transform: "translate(-307.982 1060.741)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_349",
    "data-name": "Grupo 349",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_348",
    "data-name": "Grupo 348",
    clipPath: "url(#clip-path-73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_327",
    "data-name": "Grupo 327",
    transform: "translate(1026.62)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_326",
    "data-name": "Grupo 326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_325",
    "data-name": "Grupo 325",
    clipPath: "url(#clip-path-74)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_324",
    "data-name": "Grupo 324",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_323",
    "data-name": "Grupo 323",
    clipPath: "url(#clip-path-75)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_162",
    "data-name": "Rect\\xE1ngulo 162",
    width: 15.071,
    height: 38.662,
    transform: "translate(-1.572 8.811) rotate(-81.408)",
    fill: "url(#linear-gradient-16)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_332",
    "data-name": "Grupo 332",
    transform: "translate(815.857 78.286)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_331",
    "data-name": "Grupo 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_330",
    "data-name": "Grupo 330",
    clipPath: "url(#clip-path-76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_329",
    "data-name": "Grupo 329",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_328",
    "data-name": "Grupo 328",
    clipPath: "url(#clip-path-77)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_164",
    "data-name": "Rect\\xE1ngulo 164",
    width: 20.755,
    height: 53.243,
    transform: "translate(-2.162 12.135) rotate(-81.408)",
    fill: "url(#linear-gradient-17)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_337",
    "data-name": "Grupo 337",
    transform: "translate(982.645 18.487)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_336",
    "data-name": "Grupo 336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_335",
    "data-name": "Grupo 335",
    clipPath: "url(#clip-path-78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_334",
    "data-name": "Grupo 334",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_333",
    "data-name": "Grupo 333",
    clipPath: "url(#clip-path-79)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_166",
    "data-name": "Rect\\xE1ngulo 166",
    width: 11.292,
    height: 28.969,
    transform: "translate(-1.178 6.602) rotate(-81.408)",
    fill: "url(#linear-gradient-18)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_342",
    "data-name": "Grupo 342",
    transform: "translate(436.548 98.442)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_341",
    "data-name": "Grupo 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_340",
    "data-name": "Grupo 340",
    clipPath: "url(#clip-path-80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_338",
    "data-name": "Grupo 338",
    clipPath: "url(#clip-path-81)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_168",
    "data-name": "Rect\\xE1ngulo 168",
    width: 19.524,
    height: 41.158,
    transform: "translate(-2.461 8.461) rotate(-74.975)",
    fill: "url(#linear-gradient-19)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_347",
    "data-name": "Grupo 347",
    transform: "translate(319.622 100.97)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_346",
    "data-name": "Grupo 346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_345",
    "data-name": "Grupo 345",
    clipPath: "url(#clip-path-82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_344",
    "data-name": "Grupo 344",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_343",
    "data-name": "Grupo 343",
    clipPath: "url(#clip-path-83)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_170",
    "data-name": "Rect\\xE1ngulo 170",
    width: 14.632,
    height: 30.841,
    transform: "translate(-1.845 6.342) rotate(-74.975)",
    fill: "url(#linear-gradient-20)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_418",
    "data-name": "Grupo 418",
    transform: "translate(-133.148 974.264)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_417",
    "data-name": "Grupo 417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_416",
    "data-name": "Grupo 416",
    clipPath: "url(#clip-path-84)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_355",
    "data-name": "Grupo 355",
    transform: "translate(171.519 65.748)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_354",
    "data-name": "Grupo 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_353",
    "data-name": "Grupo 353",
    clipPath: "url(#clip-path-85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_352",
    "data-name": "Grupo 352",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_351",
    "data-name": "Grupo 351",
    clipPath: "url(#clip-path-86)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_173",
    "data-name": "Rect\\xE1ngulo 173",
    width: 9.94,
    height: 24.741,
    transform: "translate(-1.068 5.338) rotate(-79.789)",
    fill: "url(#linear-gradient-21)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_360",
    "data-name": "Grupo 360",
    transform: "translate(267.286 28.182)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_359",
    "data-name": "Grupo 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_358",
    "data-name": "Grupo 358",
    clipPath: "url(#clip-path-87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_357",
    "data-name": "Grupo 357",
    transform: "translate(0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_356",
    "data-name": "Grupo 356",
    clipPath: "url(#clip-path-88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_175",
    "data-name": "Rect\\xE1ngulo 175",
    width: 13.69,
    height: 34.075,
    transform: "translate(-1.474 7.35) rotate(-79.789)",
    fill: "url(#linear-gradient-22)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_365",
    "data-name": "Grupo 365",
    transform: "translate(247.486 59.399)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_364",
    "data-name": "Grupo 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_363",
    "data-name": "Grupo 363",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_362",
    "data-name": "Grupo 362",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_361",
    "data-name": "Grupo 361",
    clipPath: "url(#clip-path-90)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_177",
    "data-name": "Rect\\xE1ngulo 177",
    width: 7.447,
    height: 18.538,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, -0.799, 3.998)",
    fill: "url(#linear-gradient-23)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_370",
    "data-name": "Grupo 370",
    transform: "translate(312.284 25.895)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_369",
    "data-name": "Grupo 369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_368",
    "data-name": "Grupo 368",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_367",
    "data-name": "Grupo 367",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_366",
    "data-name": "Grupo 366",
    clipPath: "url(#clip-path-92)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_179",
    "data-name": "Rect\\xE1ngulo 179",
    width: 7.447,
    height: 18.538,
    transform: "translate(-0.802 3.998) rotate(-79.789)",
    fill: "url(#linear-gradient-24)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(439.578 50.783)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_374",
    "data-name": "Grupo 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_373",
    "data-name": "Grupo 373",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_372",
    "data-name": "Grupo 372",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_371",
    "data-name": "Grupo 371",
    clipPath: "url(#clip-path-94)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_181",
    "data-name": "Rect\\xE1ngulo 181",
    width: 7.447,
    height: 18.538,
    transform: "translate(-0.802 3.998) rotate(-79.789)",
    fill: "url(#linear-gradient-25)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_380",
    "data-name": "Grupo 380",
    transform: "translate(127.477 86.003)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_379",
    "data-name": "Grupo 379"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_378",
    "data-name": "Grupo 378",
    clipPath: "url(#clip-path-95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_377",
    "data-name": "Grupo 377",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_376",
    "data-name": "Grupo 376",
    clipPath: "url(#clip-path-96)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_183",
    "data-name": "Rect\\xE1ngulo 183",
    width: 13.69,
    height: 34.072,
    transform: "translate(-1.471 7.35) rotate(-79.789)",
    fill: "url(#linear-gradient-26)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_385",
    "data-name": "Grupo 385",
    transform: "translate(267.731 70.935)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_384",
    "data-name": "Grupo 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_383",
    "data-name": "Grupo 383",
    clipPath: "url(#clip-path-91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_382",
    "data-name": "Grupo 382",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_381",
    "data-name": "Grupo 381",
    clipPath: "url(#clip-path-98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_185",
    "data-name": "Rect\\xE1ngulo 185",
    width: 7.45,
    height: 18.539,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, -0.802, 3.999)",
    fill: "url(#linear-gradient-27)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_390",
    "data-name": "Grupo 390",
    transform: "translate(276.659)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_389",
    "data-name": "Grupo 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_388",
    "data-name": "Grupo 388",
    clipPath: "url(#clip-path-89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    "data-name": "Grupo 387",
    transform: "translate(0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_386",
    "data-name": "Grupo 386",
    clipPath: "url(#clip-path-100)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_187",
    "data-name": "Rect\\xE1ngulo 187",
    width: 7.447,
    height: 18.538,
    transform: "translate(-0.802 3.998) rotate(-79.789)",
    fill: "url(#linear-gradient-28)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_395",
    "data-name": "Grupo 395",
    transform: "translate(378.328 81.751)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_394",
    "data-name": "Grupo 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_393",
    "data-name": "Grupo 393",
    clipPath: "url(#clip-path-101)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_392",
    "data-name": "Grupo 392",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_391",
    "data-name": "Grupo 391",
    clipPath: "url(#clip-path-102)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_189",
    "data-name": "Rect\\xE1ngulo 189",
    width: 13.556,
    height: 26.51,
    transform: "translate(-1.872 5.581) rotate(-73.356)",
    fill: "url(#linear-gradient-29)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_400",
    "data-name": "Grupo 400",
    transform: "translate(484.164 53.889)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_399",
    "data-name": "Grupo 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_398",
    "data-name": "Grupo 398",
    clipPath: "url(#clip-path-103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_397",
    "data-name": "Grupo 397",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_396",
    "data-name": "Grupo 396",
    clipPath: "url(#clip-path-104)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_191",
    "data-name": "Rect\\xE1ngulo 191",
    width: 18.672,
    height: 36.511,
    transform: "matrix(0.286, -0.958, 0.958, 0.286, -2.578, 7.687)",
    fill: "url(#linear-gradient-30)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_405",
    "data-name": "Grupo 405",
    transform: "translate(459.691 83.761)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_404",
    "data-name": "Grupo 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_403",
    "data-name": "Grupo 403",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_402",
    "data-name": "Grupo 402",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_401",
    "data-name": "Grupo 401",
    clipPath: "url(#clip-path-106)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_193",
    "data-name": "Rect\\xE1ngulo 193",
    width: 10.156,
    height: 19.864,
    transform: "translate(-1.402 4.181) rotate(-73.357)",
    fill: "url(#linear-gradient-31)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_410",
    "data-name": "Grupo 410",
    transform: "translate(532.362 55.998)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_409",
    "data-name": "Grupo 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_408",
    "data-name": "Grupo 408",
    clipPath: "url(#clip-path-107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_407",
    "data-name": "Grupo 407",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_406",
    "data-name": "Grupo 406",
    clipPath: "url(#clip-path-108)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_195",
    "data-name": "Rect\\xE1ngulo 195",
    width: 10.159,
    height: 19.865,
    transform: "translate(-1.405 4.183) rotate(-73.357)",
    fill: "url(#linear-gradient-32)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_415",
    "data-name": "Grupo 415",
    transform: "translate(664.292 97.585)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_414",
    "data-name": "Grupo 414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_413",
    "data-name": "Grupo 413",
    clipPath: "url(#clip-path-105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_412",
    "data-name": "Grupo 412",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_411",
    "data-name": "Grupo 411",
    clipPath: "url(#clip-path-110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_197",
    "data-name": "Rect\\xE1ngulo 197",
    width: 10.156,
    height: 19.864,
    transform: "translate(-1.402 4.181) rotate(-73.356)",
    fill: "url(#linear-gradient-33)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_496",
    "data-name": "Grupo 496",
    transform: "translate(1236.55 1067.037)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_495",
    "data-name": "Grupo 495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_494",
    "data-name": "Grupo 494",
    clipPath: "url(#clip-path-111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_423",
    "data-name": "Grupo 423",
    transform: "translate(230.998 70.643)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_422",
    "data-name": "Grupo 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_421",
    "data-name": "Grupo 421",
    clipPath: "url(#clip-path-112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_420",
    "data-name": "Grupo 420",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_419",
    "data-name": "Grupo 419",
    clipPath: "url(#clip-path-113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_200",
    "data-name": "Rect\\xE1ngulo 200",
    width: 10.681,
    height: 26.582,
    transform: "translate(-1.149 5.733) rotate(-79.789)",
    fill: "url(#linear-gradient-34)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428",
    transform: "translate(333.892 30.28)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_427",
    "data-name": "Grupo 427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_426",
    "data-name": "Grupo 426",
    clipPath: "url(#clip-path-114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_425",
    "data-name": "Grupo 425",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_424",
    "data-name": "Grupo 424",
    clipPath: "url(#clip-path-115)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_202",
    "data-name": "Rect\\xE1ngulo 202",
    width: 14.707,
    height: 36.608,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, -1.579, 7.896)",
    fill: "url(#linear-gradient-35)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_433",
    "data-name": "Grupo 433",
    transform: "translate(312.619 63.819)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_432",
    "data-name": "Grupo 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_431",
    "data-name": "Grupo 431",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_430",
    "data-name": "Grupo 430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    clipPath: "url(#clip-path-117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_204",
    "data-name": "Rect\\xE1ngulo 204",
    width: 8.004,
    height: 19.917,
    transform: "translate(-0.859 4.298) rotate(-79.789)",
    fill: "url(#linear-gradient-36)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_438",
    "data-name": "Grupo 438",
    transform: "translate(382.236 27.824)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_437",
    "data-name": "Grupo 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_436",
    "data-name": "Grupo 436",
    clipPath: "url(#clip-path-118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_435",
    "data-name": "Grupo 435",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_434",
    "data-name": "Grupo 434",
    clipPath: "url(#clip-path-119)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_206",
    "data-name": "Rect\\xE1ngulo 206",
    width: 8.002,
    height: 19.916,
    transform: "translate(-0.858 4.297) rotate(-79.79)",
    fill: "url(#linear-gradient-37)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_443",
    "data-name": "Grupo 443",
    transform: "translate(519.003 54.562)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_442",
    "data-name": "Grupo 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_440",
    "data-name": "Grupo 440",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_439",
    "data-name": "Grupo 439",
    clipPath: "url(#clip-path-121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_208",
    "data-name": "Rect\\xE1ngulo 208",
    width: 8.002,
    height: 19.919,
    transform: "translate(-0.861 4.295) rotate(-79.789)",
    fill: "url(#linear-gradient-38)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_448",
    "data-name": "Grupo 448",
    transform: "translate(183.681 92.403)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_447",
    "data-name": "Grupo 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_446",
    "data-name": "Grupo 446",
    clipPath: "url(#clip-path-122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_445",
    "data-name": "Grupo 445",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_444",
    "data-name": "Grupo 444",
    clipPath: "url(#clip-path-123)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_210",
    "data-name": "Rect\\xE1ngulo 210",
    width: 14.709,
    height: 36.606,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, -1.58, 7.896)",
    fill: "url(#linear-gradient-39)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_453",
    "data-name": "Grupo 453",
    transform: "translate(334.366 76.214)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_452",
    "data-name": "Grupo 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_451",
    "data-name": "Grupo 451",
    clipPath: "url(#clip-path-116)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_450",
    "data-name": "Grupo 450",
    transform: "translate(0.002 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_449",
    "data-name": "Grupo 449",
    clipPath: "url(#clip-path-125)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_212",
    "data-name": "Rect\\xE1ngulo 212",
    width: 8.005,
    height: 19.92,
    transform: "matrix(0.177, -0.984, 0.984, 0.177, -0.861, 4.298)",
    fill: "url(#linear-gradient-40)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_458",
    "data-name": "Grupo 458",
    transform: "translate(343.964)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_457",
    "data-name": "Grupo 457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_456",
    "data-name": "Grupo 456",
    clipPath: "url(#clip-path-120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_455",
    "data-name": "Grupo 455",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_454",
    "data-name": "Grupo 454",
    clipPath: "url(#clip-path-127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_214",
    "data-name": "Rect\\xE1ngulo 214",
    width: 8.002,
    height: 19.919,
    transform: "translate(-0.861 4.295) rotate(-79.789)",
    fill: "url(#linear-gradient-41)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_463",
    "data-name": "Grupo 463",
    transform: "translate(453.193 87.835)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_462",
    "data-name": "Grupo 462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_461",
    "data-name": "Grupo 461",
    clipPath: "url(#clip-path-128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_460",
    "data-name": "Grupo 460",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_459",
    "data-name": "Grupo 459",
    clipPath: "url(#clip-path-129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_216",
    "data-name": "Rect\\xE1ngulo 216",
    width: 14.565,
    height: 28.483,
    transform: "translate(-2.013 5.996) rotate(-73.356)",
    fill: "url(#linear-gradient-42)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_468",
    "data-name": "Grupo 468",
    transform: "translate(566.908 57.9)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_467",
    "data-name": "Grupo 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_466",
    "data-name": "Grupo 466",
    clipPath: "url(#clip-path-130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_465",
    "data-name": "Grupo 465",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_464",
    "data-name": "Grupo 464",
    clipPath: "url(#clip-path-131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_218",
    "data-name": "Rect\\xE1ngulo 218",
    width: 20.06,
    height: 39.225,
    transform: "translate(-2.771 8.26) rotate(-73.357)",
    fill: "url(#linear-gradient-43)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_473",
    "data-name": "Grupo 473",
    transform: "translate(540.613 89.994)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_472",
    "data-name": "Grupo 472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_471",
    "data-name": "Grupo 471",
    clipPath: "url(#clip-path-132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_470",
    "data-name": "Grupo 470",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_469",
    "data-name": "Grupo 469",
    clipPath: "url(#clip-path-133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_220",
    "data-name": "Rect\\xE1ngulo 220",
    width: 10.914,
    height: 21.341,
    transform: "translate(-1.507 4.494) rotate(-73.357)",
    fill: "url(#linear-gradient-44)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_478",
    "data-name": "Grupo 478",
    transform: "translate(618.692 60.167)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_477",
    "data-name": "Grupo 477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_476",
    "data-name": "Grupo 476",
    clipPath: "url(#clip-path-134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_475",
    "data-name": "Grupo 475",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_474",
    "data-name": "Grupo 474",
    clipPath: "url(#clip-path-135)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_222",
    "data-name": "Rect\\xE1ngulo 222",
    width: 10.912,
    height: 21.343,
    transform: "matrix(0.286, -0.958, 0.958, 0.286, -1.506, 4.492)",
    fill: "url(#linear-gradient-45)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_483",
    "data-name": "Grupo 483",
    transform: "translate(0 68.223)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_482",
    "data-name": "Grupo 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_481",
    "data-name": "Grupo 481",
    clipPath: "url(#clip-path-136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_480",
    "data-name": "Grupo 480",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_479",
    "data-name": "Grupo 479",
    clipPath: "url(#clip-path-137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_224",
    "data-name": "Rect\\xE1ngulo 224",
    width: 13.812,
    height: 34.381,
    transform: "translate(-1.483 7.416) rotate(-79.789)",
    fill: "url(#linear-gradient-46)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_488",
    "data-name": "Grupo 488",
    transform: "translate(82.694 73.986)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_487",
    "data-name": "Grupo 487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_486",
    "data-name": "Grupo 486",
    clipPath: "url(#clip-path-138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_485",
    "data-name": "Grupo 485",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_484",
    "data-name": "Grupo 484",
    clipPath: "url(#clip-path-139)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_226",
    "data-name": "Rect\\xE1ngulo 226",
    width: 34.626,
    height: 67.713,
    transform: "matrix(0.286, -0.958, 0.958, 0.286, -4.784, 14.256)",
    fill: "url(#linear-gradient-47)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_493",
    "data-name": "Grupo 493",
    transform: "translate(213.567 77.344)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_492",
    "data-name": "Grupo 492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491",
    clipPath: "url(#clip-path-140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_490",
    "data-name": "Grupo 490",
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_489",
    "data-name": "Grupo 489",
    clipPath: "url(#clip-path-141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_228",
    "data-name": "Rect\\xE1ngulo 228",
    width: 18.839,
    height: 36.841,
    transform: "matrix(0.286, -0.958, 0.958, 0.286, -2.603, 7.757)",
    fill: "url(#linear-gradient-48)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_569",
    "data-name": "Grupo 569",
    transform: "translate(1254.925 951.311)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_568",
    "data-name": "Grupo 568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_567",
    "data-name": "Grupo 567",
    clipPath: "url(#clip-path-142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_501",
    "data-name": "Grupo 501",
    transform: "translate(190.331 60.171)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_500",
    "data-name": "Grupo 500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_499",
    "data-name": "Grupo 499",
    clipPath: "url(#clip-path-143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_498",
    "data-name": "Grupo 498",
    transform: "translate(-0.001 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_497",
    "data-name": "Grupo 497",
    clipPath: "url(#clip-path-144)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_231",
    "data-name": "Rect\\xE1ngulo 231",
    width: 12.937,
    height: 26.624,
    transform: "translate(-1.68 5.513) rotate(-74.476)",
    fill: "url(#linear-gradient-49)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_506",
    "data-name": "Grupo 506",
    transform: "translate(296.401 29.951)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_505",
    "data-name": "Grupo 505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_504",
    "data-name": "Grupo 504",
    clipPath: "url(#clip-path-145)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_503",
    "data-name": "Grupo 503",
    transform: "translate(0.002 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_502",
    "data-name": "Grupo 502",
    clipPath: "url(#clip-path-146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_233",
    "data-name": "Rect\\xE1ngulo 233",
    width: 17.814,
    height: 36.664,
    transform: "matrix(0.268, -0.964, 0.964, 0.268, -2.314, 7.59)",
    fill: "url(#linear-gradient-50)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_511",
    "data-name": "Grupo 511",
    transform: "translate(272.311 60.642)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_510",
    "data-name": "Grupo 510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_509",
    "data-name": "Grupo 509",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_508",
    "data-name": "Grupo 508",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_507",
    "data-name": "Grupo 507",
    clipPath: "url(#clip-path-148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_235",
    "data-name": "Rect\\xE1ngulo 235",
    width: 9.692,
    height: 19.949,
    transform: "translate(-1.256 4.13) rotate(-74.475)",
    fill: "url(#linear-gradient-51)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_516",
    "data-name": "Grupo 516",
    transform: "translate(344.965 31.25)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_515",
    "data-name": "Grupo 515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_514",
    "data-name": "Grupo 514",
    clipPath: "url(#clip-path-147)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_513",
    "data-name": "Grupo 513",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_512",
    "data-name": "Grupo 512",
    clipPath: "url(#clip-path-150)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_237",
    "data-name": "Rect\\xE1ngulo 237",
    width: 9.692,
    height: 19.949,
    transform: "matrix(0.268, -0.964, 0.964, 0.268, -1.259, 4.13)",
    fill: "url(#linear-gradient-52)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_521",
    "data-name": "Grupo 521",
    transform: "translate(478.667 70.539)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_520",
    "data-name": "Grupo 520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_519",
    "data-name": "Grupo 519",
    clipPath: "url(#clip-path-151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_518",
    "data-name": "Grupo 518",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_517",
    "data-name": "Grupo 517",
    clipPath: "url(#clip-path-152)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_239",
    "data-name": "Rect\\xE1ngulo 239",
    width: 9.692,
    height: 19.949,
    transform: "translate(-1.259 4.13) rotate(-74.476)",
    fill: "url(#linear-gradient-53)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_526",
    "data-name": "Grupo 526",
    transform: "translate(0 116.66)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_525",
    "data-name": "Grupo 525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_524",
    "data-name": "Grupo 524",
    clipPath: "url(#clip-path-153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_523",
    "data-name": "Grupo 523",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_522",
    "data-name": "Grupo 522",
    clipPath: "url(#clip-path-154)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_241",
    "data-name": "Rect\\xE1ngulo 241",
    width: 12.934,
    height: 26.623,
    transform: "translate(-1.679 5.512) rotate(-74.476)",
    fill: "url(#linear-gradient-54)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_531",
    "data-name": "Grupo 531",
    transform: "translate(141.081 77.897)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_530",
    "data-name": "Grupo 530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_529",
    "data-name": "Grupo 529",
    clipPath: "url(#clip-path-155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_528",
    "data-name": "Grupo 528",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_527",
    "data-name": "Grupo 527",
    clipPath: "url(#clip-path-156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_243",
    "data-name": "Rect\\xE1ngulo 243",
    width: 17.814,
    height: 36.664,
    transform: "matrix(0.268, -0.964, 0.964, 0.268, -2.312, 7.59)",
    fill: "url(#linear-gradient-55)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_536",
    "data-name": "Grupo 536",
    transform: "translate(37.944 109.504)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_535",
    "data-name": "Grupo 535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_534",
    "data-name": "Grupo 534",
    clipPath: "url(#clip-path-157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_533",
    "data-name": "Grupo 533",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_532",
    "data-name": "Grupo 532",
    clipPath: "url(#clip-path-158)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_245",
    "data-name": "Rect\\xE1ngulo 245",
    width: 9.694,
    height: 19.947,
    transform: "translate(-1.256 4.131) rotate(-74.476)",
    fill: "url(#linear-gradient-56)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_541",
    "data-name": "Grupo 541",
    transform: "translate(292.819 74.996)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_540",
    "data-name": "Grupo 540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_539",
    "data-name": "Grupo 539",
    clipPath: "url(#clip-path-159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_538",
    "data-name": "Grupo 538",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_537",
    "data-name": "Grupo 537",
    clipPath: "url(#clip-path-160)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_247",
    "data-name": "Rect\\xE1ngulo 247",
    width: 9.695,
    height: 19.95,
    transform: "translate(-1.26 4.131) rotate(-74.476)",
    fill: "url(#linear-gradient-57)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_546",
    "data-name": "Grupo 546",
    transform: "translate(309.434)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_545",
    "data-name": "Grupo 545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_544",
    "data-name": "Grupo 544",
    clipPath: "url(#clip-path-161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_543",
    "data-name": "Grupo 543",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_542",
    "data-name": "Grupo 542",
    clipPath: "url(#clip-path-162)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_249",
    "data-name": "Rect\\xE1ngulo 249",
    width: 9.692,
    height: 19.949,
    transform: "translate(-1.259 4.13) rotate(-74.476)",
    fill: "url(#linear-gradient-58)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_551",
    "data-name": "Grupo 551",
    transform: "translate(410.087 97.395)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_550",
    "data-name": "Grupo 550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_549",
    "data-name": "Grupo 549",
    clipPath: "url(#clip-path-163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_548",
    "data-name": "Grupo 548",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_547",
    "data-name": "Grupo 547",
    clipPath: "url(#clip-path-164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_251",
    "data-name": "Rect\\xE1ngulo 251",
    width: 18.018,
    height: 28.753,
    transform: "translate(-3.121 6.636) rotate(-68.043)",
    fill: "url(#linear-gradient-59)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_556",
    "data-name": "Grupo 556",
    transform: "translate(526.007 78.386)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_555",
    "data-name": "Grupo 555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_554",
    "data-name": "Grupo 554",
    clipPath: "url(#clip-path-165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_553",
    "data-name": "Grupo 553",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_552",
    "data-name": "Grupo 552",
    clipPath: "url(#clip-path-166)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_253",
    "data-name": "Rect\\xE1ngulo 253",
    width: 24.812,
    height: 39.598,
    transform: "translate(-4.299 9.138) rotate(-68.044)",
    fill: "url(#linear-gradient-60)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_561",
    "data-name": "Grupo 561",
    transform: "translate(496.981 107.466)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_560",
    "data-name": "Grupo 560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_559",
    "data-name": "Grupo 559",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_558",
    "data-name": "Grupo 558",
    transform: "translate(0.002 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_557",
    "data-name": "Grupo 557",
    clipPath: "url(#clip-path-168)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_255",
    "data-name": "Rect\\xE1ngulo 255",
    width: 13.499,
    height: 21.543,
    transform: "translate(-2.339 4.971) rotate(-68.044)",
    fill: "url(#linear-gradient-61)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_566",
    "data-name": "Grupo 566",
    transform: "translate(577.49 84.998)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_565",
    "data-name": "Grupo 565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_564",
    "data-name": "Grupo 564",
    clipPath: "url(#clip-path-167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_563",
    "data-name": "Grupo 563",
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_562",
    "data-name": "Grupo 562",
    clipPath: "url(#clip-path-170)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_257",
    "data-name": "Rect\\xE1ngulo 257",
    width: 13.5,
    height: 21.546,
    transform: "translate(-2.339 4.971) rotate(-68.044)",
    fill: "url(#linear-gradient-62)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_572",
    "data-name": "Grupo 572",
    transform: "translate(336.109 968.997)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_571",
    "data-name": "Grupo 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_570",
    "data-name": "Grupo 570",
    clipPath: "url(#clip-path-171)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3584",
    "data-name": "Trazado 3584",
    d: "M770.349,386.309,575.067,370.8V350s-125.361-3.881-143.614-10.169-178.776-4.574-178.776-4.574l203.691-3.931L625.2,335.239v16.586s190.633,12.485,198.4,17.425-53.245,17.059-53.245,17.059",
    transform: "translate(-252.677 -331.326)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_575",
    "data-name": "Grupo 575",
    transform: "translate(917.564 948.82)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_574",
    "data-name": "Grupo 574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_573",
    "data-name": "Grupo 573",
    clipPath: "url(#clip-path-172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3585",
    "data-name": "Trazado 3585",
    d: "M621.973,349.232s-64.435-16.591-73.762-18.8-35.323,1.658-51.365,0-45.355-6-45.355-6,60,16.512,66.784,16.512S579.741,353.1,579.741,353.1Z",
    transform: "translate(-451.491 -324.425)",
    fill: "#c49fa4",
    fillRule: "evenodd"
  }))))))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_272",
    "data-name": "Grupo 272",
    transform: "translate(10063.863 11414.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_271",
    "data-name": "Grupo 271",
    clipPath: "url(#clip-path-173)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_141",
    "data-name": "Rect\\xE1ngulo 141",
    width: 6.714,
    height: 8.884,
    transform: "translate(-3.385 1.409) rotate(-24.664)",
    fill: "url(#radial-gradient-16)"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_270",
    "data-name": "Grupo 270",
    transform: "translate(10052.206 11424.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_269",
    "data-name": "Grupo 269",
    clipPath: "url(#clip-path-174)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_140",
    "data-name": "Rect\\xE1ngulo 140",
    width: 4.526,
    height: 4.836,
    transform: "translate(-1.288 3.023) rotate(-70.365)",
    fill: "url(#radial-gradient-17)"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_268",
    "data-name": "Grupo 268",
    transform: "translate(10050.993 11415.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_267",
    "data-name": "Grupo 267",
    clipPath: "url(#clip-path-175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_139",
    "data-name": "Rect\\xE1ngulo 139",
    width: 10.53,
    height: 11.247,
    transform: "matrix(0.336, -0.942, 0.942, 0.336, -2.998, 7.033)",
    fill: "url(#radial-gradient-18)"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    "data-name": "Grupo 264",
    transform: "translate(10060.536 11395.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263",
    clipPath: "url(#clip-path-176)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_137",
    "data-name": "Rect\\xE1ngulo 137",
    width: 102.941,
    height: 201.27,
    transform: "translate(-60.426 20.512) rotate(-18.75)",
    fill: "url(#linear-gradient-63)"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_244",
    "data-name": "Grupo 244",
    transform: "translate(10044.652 11480.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_243",
    "data-name": "Grupo 243",
    clipPath: "url(#clip-path-177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_127",
    "data-name": "Rect\\xE1ngulo 127",
    width: 65.024,
    height: 118.889,
    transform: "matrix(0.947, -0.321, 0.321, 0.947, -35.173, 11.94)",
    fill: "url(#linear-gradient-64)"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_208",
    "data-name": "Grupo 208",
    transform: "translate(10023.736 11505.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207",
    clipPath: "url(#clip-path-178)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_109",
    "data-name": "Rect\\xE1ngulo 109",
    width: 10.598,
    height: 9.355,
    transform: "matrix(0.909, -0.417, 0.417, 0.909, -2.661, 1.087)",
    fill: "url(#radial-gradient-19)"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_206",
    "data-name": "Grupo 206",
    transform: "translate(10032.802 11507.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_205",
    "data-name": "Grupo 205",
    clipPath: "url(#clip-path-179)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_108",
    "data-name": "Rect\\xE1ngulo 108",
    width: 29.311,
    height: 30.022,
    transform: "matrix(0.909, -0.417, 0.417, 0.909, -10.104, 4.022)",
    fill: "url(#radial-gradient-20)"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_246",
    "data-name": "Grupo 246",
    transform: "translate(10037.462 11469.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_245",
    "data-name": "Grupo 245",
    clipPath: "url(#clip-path-180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_128",
    "data-name": "Rect\\xE1ngulo 128",
    width: 35.159,
    height: 35.273,
    transform: "translate(-11.757 4.644) rotate(-24.663)",
    fill: "url(#radial-gradient-21)"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_250",
    "data-name": "Grupo 250",
    transform: "translate(10061.304 11469.14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_249",
    "data-name": "Grupo 249",
    clipPath: "url(#clip-path-181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_130",
    "data-name": "Rect\\xE1ngulo 130",
    width: 3.672,
    height: 3.685,
    transform: "translate(-1.229 0.485) rotate(-24.664)",
    fill: "url(#radial-gradient-22)"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_252",
    "data-name": "Grupo 252",
    transform: "translate(10047.149 11495.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_251",
    "data-name": "Grupo 251",
    clipPath: "url(#clip-path-182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_131",
    "data-name": "Rect\\xE1ngulo 131",
    width: 5.045,
    height: 6.675,
    transform: "translate(-2.541 1.058) rotate(-24.664)",
    fill: "url(#radial-gradient-23)"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_248",
    "data-name": "Grupo 248",
    transform: "translate(10055.592 11470.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_247",
    "data-name": "Grupo 247",
    clipPath: "url(#clip-path-183)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_129",
    "data-name": "Rect\\xE1ngulo 129",
    width: 8.544,
    height: 8.571,
    transform: "translate(-2.857 1.129) rotate(-24.664)",
    fill: "url(#radial-gradient-24)"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216",
    transform: "translate(10173.236 11517.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215",
    clipPath: "url(#clip-path-184)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_113",
    "data-name": "Rect\\xE1ngulo 113",
    width: 6.933,
    height: 7.798,
    transform: "translate(-2.286 4.327) rotate(-69.115)",
    fill: "url(#radial-gradient-25)"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214",
    transform: "translate(10158.352 11520.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_213",
    "data-name": "Grupo 213",
    clipPath: "url(#clip-path-185)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_112",
    "data-name": "Rect\\xE1ngulo 112",
    width: 22.098,
    height: 21.308,
    transform: "matrix(0.356, -0.934, 0.934, 0.356, -6.816, 15.274)",
    fill: "url(#radial-gradient-26)"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260",
    transform: "translate(10156.8 11494.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259",
    clipPath: "url(#clip-path-186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_135",
    "data-name": "Rect\\xE1ngulo 135",
    width: 2.052,
    height: 2.118,
    transform: "translate(-0.461 0.085) rotate(-12.61)",
    fill: "url(#radial-gradient-27)"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258",
    transform: "translate(10152.793 11494.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_257",
    "data-name": "Grupo 257",
    clipPath: "url(#clip-path-187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_134",
    "data-name": "Rect\\xE1ngulo 134",
    width: 4.773,
    height: 4.926,
    transform: "translate(-1.074 0.198) rotate(-12.609)",
    fill: "url(#radial-gradient-28)"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_254",
    "data-name": "Grupo 254",
    transform: "translate(10141.819 11499.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_253",
    "data-name": "Grupo 253",
    clipPath: "url(#clip-path-188)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_132",
    "data-name": "Rect\\xE1ngulo 132",
    width: 24.472,
    height: 92.779,
    transform: "translate(-10.633 1.249) rotate(-6.698)",
    fill: "url(#linear-gradient-65)"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_256",
    "data-name": "Grupo 256",
    transform: "translate(10140.054 11492.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_255",
    "data-name": "Grupo 255",
    clipPath: "url(#clip-path-189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_133",
    "data-name": "Rect\\xE1ngulo 133",
    width: 19.632,
    height: 20.263,
    transform: "matrix(0.976, -0.218, 0.218, 0.976, -4.417, 0.816)",
    fill: "url(#radial-gradient-29)"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224",
    transform: "translate(10245.58 11509.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223",
    clipPath: "url(#clip-path-190)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_117",
    "data-name": "Rect\\xE1ngulo 117",
    width: 5.163,
    height: 5.808,
    transform: "translate(-1.705 3.222) rotate(-69.115)",
    fill: "url(#radial-gradient-30)"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220",
    transform: "translate(10229.892 11515.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219",
    clipPath: "url(#clip-path-191)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_115",
    "data-name": "Rect\\xE1ngulo 115",
    width: 45.001,
    height: 21.889,
    transform: "matrix(0.258, -0.966, 0.966, 0.258, -10.892, 40.731)",
    fill: "url(#linear-gradient-66)"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222",
    transform: "translate(10234.503 11511.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221",
    clipPath: "url(#clip-path-192)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_116",
    "data-name": "Rect\\xE1ngulo 116",
    width: 16.445,
    height: 15.858,
    transform: "translate(-5.073 11.366) rotate(-69.115)",
    fill: "url(#radial-gradient-31)"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_234",
    "data-name": "Grupo 234",
    transform: "translate(10238.379 11543.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_233",
    "data-name": "Grupo 233",
    clipPath: "url(#clip-path-193)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_122",
    "data-name": "Rect\\xE1ngulo 122",
    width: 11.243,
    height: 10.841,
    transform: "translate(-3.468 7.771) rotate(-69.115)",
    fill: "url(#radial-gradient-32)"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_266",
    "data-name": "Grupo 266",
    transform: "translate(10046.232 11381.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_265",
    "data-name": "Grupo 265",
    clipPath: "url(#clip-path-194)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_138",
    "data-name": "Rect\\xE1ngulo 138",
    width: 46.798,
    height: 46.95,
    transform: "translate(-15.646 6.182) rotate(-24.664)",
    fill: "url(#radial-gradient-33)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_267",
    "data-name": "Rect\\xE1ngulo 267",
    width: 2638.519,
    height: 1335.969,
    transform: "translate(8050 10514.141)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMars);
export default __webpack_public_path__ + "static/media/mars.d0163854f5f1315211a514139e7d53bb.svg";
export { ForwardRef as ReactComponent };